import staggerAttachments, { YES_OPTION, NO_OPTION } from 'projectDesign/components/projectConfiguration/fields/staggerAttachments';
import AdjustableTiltSystem from 'projectDesign/components/projectConfiguration/fields/adjustableTiltSystem';
import elevation from '../fields/elevation';
import buildingCode, { apiField as buildingCodeApiField } from '../fields/buildingCode';
import topographicalFactorKzt, { apiField as topographicalFactorKztApiField } from '../fields/topographicalFactorKzt';
import { apiField as velocityPressureExposureCofficientKzApiField } from '../fields/velocityPressureExposureCoefficientKz';
import { apiField as groundElevationFactorKeApiField } from '../fields/groundElevationFactorKe';
import thermalFactor, { apiField as thermalFactorApiField } from '../fields/thermalFactor';
import { apiField as useDefaultFlatSlopeRoofSnowLoadApiField } from '../fields/useDefaultFlatSlopeRoofSnowLoad';
import { apiField as flatRoofSnowLoadApiField } from '../fields/flatRoofSnowLoad';
import { apiField as preferredSpanApiField } from '../fields/span';
import { apiField as windSpeedApiField } from '../fields/windSpeed';
import { apiField as railFinishApiField } from '../fields/railFinish';
import { apiField as meanRecurrenceApiField } from '../fields/meanRecurrenceInterval';
import { apiField as windExposureApiField } from '../fields/types/windExposure';
import { apiField as nbccRoughnessApiField } from '../fields/nbccRoughness';
import { apiField as roofTypeApiField } from '../fields/roofType';
import { asce_710, asce_716, asce_722, isASCE705, isASCE710, isASCE716, isASCE716or722, isASCE722 } from '__common/constants/buildingCodes';
import { GET_ENVIRONMENTAL_FACTORS, CLEAR_ENV_FACTORS_FOR, SET_PROJECT_OPTION, SET_CITY_NAME, REMOVE_OPTION_FROM_CONFIG, SET_FIELD_INVALID, OPEN_DRAWER_PAGE, SET_SEISMIC_DESIGN_CATEGORY, CLEAR_INVALID_FIELD, SET_FIELD_WARNING, TOGGLE_INPUT_UNIT, SET_FLYOUT_VERIFIED, REMOVE_OPTIONS_FROM_CONFIG, SET_PRODUCT_ID, SET_RAILS_PRODUCT_ID } from '../projectConfigurationActions';
import { areRequiredFieldsSet, buildingCodeHasChangedToAsce716or722, shouldRecalculateAsce716, shouldRecalculateNonAsce716or722 } from 'projectDesign/components/asce716switch/asce716switchHelper';
import { disableObstructionZoneView, enableObstructionsZoneView, disableWindZoneView } from '__editor/panelsEditor/components/roofZones/roofZonesHelper';
import { switchProjectToASCE716, switchProjectToNonASCE716, recalculateRoofZonesForPanels, getSpacings, getProjectRoofs } from 'projectDesign/components/asce716switch/asce716switch';
import { getBuildingHeight, getYesOrNo, isASCE716or722BuildingCode, isASCE716or722Selected, isASCE722BuildingCode, isFlatRoof } from '../projectConfiguration';
import { getMapCenter, setCenterForCurrentMap } from '__editor/components/roofsSelector/components/roofsSelectorMap/roofsSelectorMap';
import { dispatch, state } from '__common/store';
import { getAreaByZip } from '__editor/components/roofsSelector/components/roofsSelectorMap/utils/getAreaByZip';
import { ICITY_STATE } from '__editor/components/roofsSelector/components/roofsSelectorMap/utils/cityModel';
import { CLEAR_WARNING, DELETE_PANELS_INSIDE_OF_ROOF, HIDE_CONFIRM_CLEAR_ARRAYS_MODAL, OPEN_CONFIRM_CLEAR_ARRAYS_MODAL, REPLACE_PANELS_ON_ROOF, RESET_MODULE_SELECTOR, SET_LOCATION, SET_MODEL_DATA_HAS_ERROR, SET_ROOF_ROOF_PITCH, UPDATE_BLANK_MAP_ROOF_LENGTH_WIDTH_FOR_BLANK_ROOF } from 'actions';
import { SET_TILTED_ROOF, SET_ROW_SPACING, SET_COLUMN_SPACING } from '__editor/panelsEditor/actions';
import residentalBuildingTypes from '../fields/residentalBuildingTypes';
import clampsChoice from '../fields/clampsChoice';
import { ulaClampsType } from '../fields/clampTypeChoice';
import rafterSpacing, { apiField as rafterSpacingApiField } from '../fields/rafterSpacing';
import { inchesToMeters } from '__common/calculations/inchesToMeters';
import riskCategory, { apiField as riskCategoryApiField, RiskCategory } from '../fields/riskCategory';
import { apiField as snowLoadApiField } from '../fields/types/snowLoad';
import { apiField as tiltApiField } from '../fields/tilt';
import { midClampsApiField } from '../fields/smClamps';
import { FoundationType, apiField as foundationTypeApiField, options as foundationTypeOptions } from '../fields/foundationType';
import { apiField as foundationLengthApiField, FOUNDATION_LENGTH } from '../fields/foundationLength';
import { apiField as foundationDiameterApiField } from '../fields/foundationDiameter';
import frontEdgeHeight, { MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN, apiField as frontEdgeHeightApiField } from '../fields/frontEdgeHeight';
import { apiField as smClampsChoicesApiField, smClampsOptions } from 'projectDesign/components/projectConfiguration/fields/smClamps';
import { apiField as deadLoadFactorApiField } from '../fields/types/deadLoadFactor';
import { apiField as seismicSsApiField } from 'projectDesign/components/projectConfiguration/fields/types/seismicSs';
import { apiField as seismicS1ApiField } from 'projectDesign/components/projectConfiguration/fields/seismicS1';
import { apiField as iceThicknessApiField } from '../fields/iceThickness';
import { apiField as limitDownPointLoadsApiField } from '../fields/limitDownPointLoads';
import { apiField as windOnIceApiField } from '../fields/windOnIce';
import { showErrorAlert, showWarningAlert } from '__common/modules/alerts';
import { isSFMFamily, isGFT, isResidentialProduct, isRMFamily, isULA, isRMIFIProduct, isMetalX, isSolarMount, isSfmInfinity, isRMGridFlex, isRM10, isNxtHorizon, isEcoFoot2Plus, isRM10Evolution, isSMTilt, isRM10orRM10Evo, isAscender, isRM5, isSMTiltPR, isRMAndEcofootFamily, isAdditionalUserInputEnabledProduct, isOnlyAsce716ProductFamily, isRMDT, isSMAscenderFlush, isSunframeMicroRail, isCanadianChangesProduct, isCommercialProduct, isSFMInfinity, isRmGridflex10D, isGroundProduct, isNxtTilt, productHasAsce716BuildingCode, productHasAsce722BuildingCode, isSMRegular, isNxtHorizonHD, isSMTiltPRWithAscender, isRmGridflex5Rwdi, disabled722BuildingCodeProducts, isSMLT } from '__common/constants/products';
import { shouldUseStaggerAttachmentsForSfm, MINIMUM_SNOW_LOAD_THAT_REQUIRES_STAGGER_ATTACHMENTS } from 'projectDesign/components/projectConfiguration/constraints/constraints';
import { flat, gable } from '__common/constants/buildingTypes';
import _, { get, round } from 'lodash';
import { getDefaultFoundationLength } from '../configurations/GftConfig';
import { apiField as foundationTypeULAApiField, options as foundationTypeULAOptions } from '../fields/foundationTypeUla';
import { apiField as foundationDiameterULAApiField } from '../fields/foundationDiameterUla';
import { apiField as foundationScrewLengthApiField } from '../fields/foundationScrewLength';
import { apiField as parapetHeightInputApiField } from '../fields/rmIFIParapetHeight';
import { apiField as groundScrewManufacturerApiField } from '../fields/groundScrewManufacturerULA';
import { apiField as parapetHeightApiField } from '../fields/rm10ParapetHeight';
import { apiField as setbackDistanceApiField } from '../fields/setBackDistance';
import { apiField as allowMechanicalAttachmentsApiField } from '../fields/allowMechanicalAttachments';
import { apiField as attachmentOptimizationCriteriaApiField, AttachmentOptimization } from '../fields/attachmentOptimizationCriteria';
import { apiField as attachmentTypeApiField, AttachmentType } from '../fields/attachmentType';
import roofPsfLimit, { apiField as roofPsfLimitApiField } from '../fields/roofPsfLimit';
import { apiField as soilClassApiField, SOIL_CLASS } from '../fields/soilClass';
import { apiField as rmIFIParapetHeightApiField, rmIFIParapetHeightMetricField as rmIFIParapetHeightMetric, rmIFIParapetHeightField as rmIFIParapetHeight } from '../fields/rmIFIParapetHeight';
import totalWeightonRoofLimit, { apiField as totalWeightOnRoofLimitApiField } from '../fields/totalWeightOnRoofLimit';
import { apiField as shearAllowableApiField, shearAllowableForCustom, shearAllowableForUAnchor, shearAllowableForFlashloc, shearAllowableForOMG, shearAllowabledefaultValueKg, shearAllowabledefaultValue } from '../fields/shearAllowable';
import { apiField as upliftAllowableApiField, upliftAllowableForFlashloc, upliftAllowableForUAnchor, upliftAllowableForCustom, upliftAllowableForOMG, upliftAllowabledefaultValueKg, upliftAllowabledefaultValue } from '../fields/upliftAllowable';
import { apiField as ballastBlockWeightApiField, ballastBlockWeightField } from '../fields/ballastBlockWeight';
import { checkAdditionalUserInputs, checkFieldNotEmpty, checkParapetHeightRmIFIEvo, checkSeismicS1, checkSeismicSs, checkSetbackDistance, checkThickness, getBuildingHeightLimits, getLongestBuildingLengthLimits, getSetbackLimits, getShortestBuildingLengthLimits, getSnowLoadLimits, getWindSpeedLimits, parseNumberFromText } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/utils/validateProject';
import { getSeismicDesignCategory } from '__common/calculations/seismic_design_category';
import { makeAllRoofsEmpty, makeRoofEmpty } from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorDrawingManager';
import { apiField as frostDepthApiField } from '../fields/frostDepthGft';
import { apiField as solarhookapifield } from '../fields/smSolarhooksAttachments';
import { apiField as solarhooksOrTileReplacementApiField, TileAttachmentType } from '../fields/smTileReplacementsOrSolarhooks';
import { apiField as smRooftypeApiField } from '../fields/roofType';
import { apiField as materialThicknessApiField } from '../fields/roofMaterialThicknessSolarMountFlush';
import { additionalUserInputsPage, additionalUserInputsPageDependencyFields, additionalUserInputsRequiredFields, allowingZeroValuesInFourthFlyout, FIELD_FLYOUT_MAPPING, interiorBayCapacity, isHalfBlockAllowed, locationAndLoadsPageApiFields, MAX_BLOCK_COUNTS, MidEndClampChoice, minBlockCount, NxtHorizonRailType, railSystemPageApiFields, removeUpslopeRail, rm5MaxBlockCount, RmRoofType, RoofMaterialThickness, RoofSubstrate, RoofType, TileReplacementOrSolarhooks, uAnchorPartNumberApiField, UanchorSubCategoryType, ULAClampLocationType, ULARailType, s5UltimateLoadApiField, s5ShearLoadApiField, ribOrRafter, rmGridflex10MaxBlockNorthCornerCount, rmGridflex10MaxBlockCount, rmGridflex5dMaxBlockCount } from './constants';
import { apiField as centralSupportApiField } from '../fields/centralSupport';
import { apiField as anchorTypeApiField } from '../fields/uAnchorType';
import buildingHeight, { apiField as buildingHeightApiField } from '../fields/buildingHeight';
import { apiField as ballastBlockHalfWeightApiField, ballastBlockHalfWeightField } from 'projectDesign/components/projectConfiguration/fields/ballastHalfBlockWeight';
import roundingHalfBlock from 'projectDesign/components/projectConfiguration/fields/roundingHalfBlock';
import { getMaxSetBack, getSeismicSetback } from '__editor/panelsEditor/components/roofZones/utils/setBackDistanceCollisionDetections';
import { filterOutPanelsNotInsideRoofEdges } from 'projectDesign/rmGridflexBlankMapUtils';
import { metersToFeets } from '__common/calculations/metersToFeets';
import { apiField as metalXAttachmentTypeField, getAttachmentTypeOptions, ATTACHMENT_TYPES } from '../fields/metalXAttachmentType';
import { apiField as metalXRoofTypeApiField, ROOF_TYPES } from '../fields/metalXRoofType';
import { apiField as mxMaterialThicknessApiField, MATERIAL_THICKNESS, configStandingSeam, configCorrugated, configRPanel } from '../fields/metalXMaterialThickness';
import { apiField as roofSubstrateApiField } from '../fields/roofSubstrate';
import { isBoolean } from 'lodash';
import nbccWindPressure, { apiField as nbccWindPressureApiField } from '../fields/nbccWindPressure';
import { isCanadianZipcode as checkCanadianZipcode, validateZipCode, changeSetbackDistanceWarning, isOsbOrPlywood, isSpanMultipleOfRafterSpacing, validateRafterSpacing, validateSpans, validateSpansMinMax, showTornadoSpeedWarning, validateSnowImportanceFactor, validateSeismicImportanceFactor, validateWindImportanceFactor } from './validation';
import { apiField as longestBuildingLengthApiField } from '../fields/longestBuildingLength';
import { apiField as shortestBuildingLengthApiField } from '../fields/shortestBuildingLength';
import { getEditorCenter } from '__editor/panelsEditor/components/background/background';
import { deleteAllPanels, removePanelsWithNoSiblings } from '__editor/panelsEditor/components/panels/utils/panelsManagment';
import { clearRTree, insertPanelIntoRtree } from '__editor/panelsEditor/components/panels/panelsCollisions';
import { getPanelCollisionBounds } from '__editor/panelsEditor/components/panels/panels';
import { checkObstructionZoneForPanels } from '__editor/panelsEditor/components/obstructions/obstructionsCollisions';
import store from '__common/store';
import { apiField as maxDownPointLoadToBeAllowedApiField, maxDownPointLoadToBeAllowedField } from '../fields/maxDownPointLoadToBeAllowed';
import { checkCentralSupportConditionForSnowloadAndHeight, updateProjectOptionsOnModuleDimsChange, disableMandatoryMidSupportCondition } from './updateModuleDims';
import { clampLocation } from '../fields/clampLocations';
import { calculateKe, calculateKz, get_numerical_coefficient, get_design_life_factor, getFrictionFactor } from './coefficients';
import designLifeFactorFc from '../fields/designLifeFactorFc';
import numericalCoefficient from '../fields/numericalCoefficient';
import meanRecurrenceInterval from '../fields/meanRecurrenceInterval';
import { apiField as railTypeApiField } from '../fields/railType';
import { applyCentralSupportForRM5, applyShortestBuildingLength, applyRM5Revamp, applyDeadloadFactorLimitChanges, needNewZoneClassification, applyEcoFoot2PlusRM10andEvoSetbackChanges, applyRemoveMRI25ForEF, greaterThanEqualToProjectVersion, applyKrinnerGroundScrewULA, adjustableTiltSystem, frontEdgeHeightMaxLimitChange, uAnchorAttachments, uAnchorImprovements, s5AttachmentsVersion, applyAsce722AccessForEcoFoot2Plus, applyAsce722AccessForRM10Evo, applySMDomesticContentClampFilter } from '__common/utils/versionCompare/versionCompare';
import parapetHeightNumeric from '../fields/parapetHeightNumeric';
import railLengthForThermalGap from '../fields/railLengthForThermalGap';
import allowThermalGap from '../fields/allowThermalGap';
import { cmsToFeets, cmsToInches, feetsToCms, inchesToCms, kgsToLbs, kmsToMiles, kpaToPsf, lbsToKgs, metersToCms, milesToKms, psfToKpa } from '__common/calculations/unitConversions';
import { updateRoofDimensions as updateRoofDimensionsBingMap } from '__editor/bingMapsRoofsSelector/components/bingMapsRoofsSelectorDrawingManager/bingMapsRoofsSelectorDrawingManager';
import { updateRoofDimensions as updateRoofDimensionsGoogleMap } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManager';
import { apiField as buildingStoreyApiField } from '../fields/buildingStorey';
import { buildingHeightCheck } from '../constraints/constraints';
import { shouldUseSetBackDistance } from '__editor/panelsEditor/panelsEditorHelper';
import { anyPanelsDrawn, anyRoofHasManualAttachments, anyRoofHasPanels, deleteManualAttachmentsOnPanels, hasNoRoofs } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerHelper';
import { apiField as allowManualAttachmentsApiField } from '../fields/allowManualAttachments';
import { apiField as mandatorymidsupportApiField } from '../fields/mandatorymidsupport';
import { VERSION_MAP } from '__common/utils/versionCompare/version_info';
import { isMetricUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';
import { isBingMap, isGoogleMap } from '__common/constants/map';
import { apiField as rainLoadApiField } from '../fields/rainLoad';
import { metersToInches } from 'maths';
import { ADDITIONAL_USER_INPUTS_PAGE, LOCATION_AND_LOADS_PAGE, MODULE_SELECTION_PAGE, RAIL_SYSTEM_PAGE } from './projectConfigurationDrawerPages';
import seismicSds from 'projectDesign/components/projectConfiguration/fields/seismicSds';
import seismicSd1 from 'projectDesign/components/projectConfiguration/fields/seismicSd1';
import tornadoSpeed, { metricTornadoSpeedField } from '../fields/tornadoSpeed';
import longTransitionPeriods from '../fields/longTransitionPeriods';
import longestRowLength from '../fields/longestRowLength';
import shortestRowLength from '../fields/shortestRowLength';
import { feetsToMeters } from '__common/calculations/feetsToMeters';
import { apiField as railArrangementTypeApiField, options as railArrangementTypeOptions } from '../fields/railArrangementType';
import { apiField as topChordApiField, options as topChordOptions } from '../fields/topChord';
import { endClampsApiField } from '../fields/smClamps';
import { apiField as isDomesticMLPERequiredField } from '../fields/isDomesticMLPERequired';
import { apiField as domesticContentField } from '../fields/isDomesticContent';
import { apiField as railClampOptionApiField, NXTRailClampOption } from "../fields/railClampOption";
import { apiField as railDirectionApiField } from "../fields/railDirection";
import { apiField as addRoofPadsEverywhere } from '../fields/roofPadsEveryWhereField';
import { apiField as useFriction } from '../fields/useFrictionField';
import { roof_type_mapping, u_anchor_roofs_list } from './uAnchorAttachmentsFilters';
import { apiField as manufacturerField } from '../fields/manufacturerField';
import { apiField as rm_roof_type } from '../fields/rm5roofType';
import { apiField as colourField } from '../fields/colourField';
import { apiField as choiceOfFastendField } from '../fields/choiceOfFastend';
import { apiField as subCategoryField } from '../fields/roofTypeSubCategoryField';
import { canShowSkewZone } from '__common/components/exposure/exposureHelper';
import { reCalculateSkewZoneAndPanelsForAllRoofs } from '__editor/panelsEditor/components/skewZones/drawSkewZonesOnStage';
import { apiField as frictionFactorApiField, getLimitsOfFrictionCoefficient } from '../fields/frictionFactor';
import { apiField as fullyAdheredApiField } from '../fields/fullyAdhered';
import { apiField as seismicIpApiField, SEISMIC_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY } from '../fields/seismicIp';
import { apiField as snowIsApiField, SNOW_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY } from '../fields/snowIs';
import { apiField as windIwApiField } from '../fields/windIw';
import { apiField as loadSharingTypeApiField, loadSharingOptions } from '../fields/loadSharingType';

import { apiField as windDirectionalityFactorKdApiField  } from '../fields/windDirectionalityFactorKd';
import { apiField as rmTopographicalFactorKztApiField  } from '../fields/rmTopographicalFactorKzt';
import { apiField as numericalCoefficientApiField  } from '../fields/numericalCoefficient';
import { apiField as designLifeFactorFcApiField  } from '../fields/designLifeFactorFc';
import { ACCESS_FOR_7_22_PERMISSION, MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION } from 'user/userGroups';
import { apiField as StandoffHeightApiField, StandoffHeightOptions  } from '../fields/standoffHeight';
import { apiField as maxBlockCountApiField } from '../fields/maxBlockCountField';
import { apiField as minBlockCountApiField } from '../fields/minBlockCountField';
import { apiField as maxBlockNorthCornerCountApiField } from '../fields/maxBlockNorthCornerCountField';
import { apiField as interiorBayCapacityApiField } from '../fields/interiorBayCapacityField';
import { apiField as centralSupportChoiceApiField, centralSupportChoices } from '../fields/centralSupportChoice';
import { apiField as s5RoofManufacturerTypeField } from "../fields/s5RoofManufacturerField";
import { apiField as s5RoofPanelTypeField } from "../fields/s5RoofPanelField";
import { apiField as s5RoofMaterialTypeField } from "../fields/s5RoofMaterialField";
import { apiField as s5ClampTypeField } from "../fields/s5ClampField";
import { apiField as s5AttachmentpreferenceField } from '../fields/s5AttachmentpreferenceField';
import { extractUniqueS5Values, filterDataByFields, getDefaultNxtS5AssemblyClamp, getNxtS5AssemblyCapacityClamp, getS5DataValue, isGeneric, minUltimateLoad, s5AttachmentDictKeys, s5AttachmentPreferenceDict, s5AttachmentsData } from '../utils/s5AttachmentsFilters';
import { apiField as useDefaultMinAndMaxBlockCount } from '../fields/useDefaultMinAndMaxBlockCount';
import { apiField as useDefaultMaxBlockForNorthCorner } from '../fields/useDefaultMaxBlockForNorthCorner';
import { warningMsggFor722BuildingCode } from '__editor/components/roofsSelector/components/roofsSelectorSaveLoadProject/saveProject';


const SDC_AFFECTING_FIELDS = [seismicSsApiField, seismicS1ApiField, buildingCodeApiField, riskCategoryApiField, soilClassApiField];

const PRO_SERIES = '11';
const STANDARD = '01';
export const RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS = [...SDC_AFFECTING_FIELDS, parapetHeightInputApiField, setbackDistanceApiField];
const RM_ECOFOOT_SETBACK_AFFECTING_FIELDS = [...RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS, parapetHeightApiField, buildingHeightApiField, seismicSds.apiField,seismicSd1.apiField];

export const RESTRICTED_ROOF_PITCH_SDC_VALUES = ['C', 'D', 'E', 'F'];
let activeCheckboxes = {};

export const getActiveCheckboxes = () => {
  return activeCheckboxes;
};

export const addActiveCheckbox = (field: string, value: any) => {
  activeCheckboxes[field] = value;
};

export const clearActiveCheckboxes = () => {
  activeCheckboxes = {};
};

export const disableFlyoutsVerified = (field, productId) => {
  const { projectConfiguration: { projectEnvConfig, formState: { invalidFields }, verifiedFlyouts } } = state();

  // check zipcode everytime
  if (!validateZipCode(projectEnvConfig.zipcode)) {
    dispatch(SET_FLYOUT_VERIFIED(LOCATION_AND_LOADS_PAGE, false, true));
    return;
  }

  for (const { fieldName } of invalidFields) {
    dispatch(SET_FLYOUT_VERIFIED(FIELD_FLYOUT_MAPPING[fieldName], false, true));
  }
  // check additionalInputFields everytime
  if (isAdditionalUserInputEnabledProduct(productId) && (additionalUserInputsPageDependencyFields.includes(field) || additionalUserInputsPage(productId).includes(field))) {
    for (const key of additionalUserInputsRequiredFields(productId, projectEnvConfig)) {
      const value = projectEnvConfig[key];
      const isMissing = allowingZeroValuesInFourthFlyout.includes(key) ?
        value === null || value === undefined || value === '' :
        !value;
      if (isMissing) {
        dispatch(SET_FLYOUT_VERIFIED(ADDITIONAL_USER_INPUTS_PAGE, false, true));
        return;
      }
    }
    if (verifiedFlyouts[ADDITIONAL_USER_INPUTS_PAGE].error) {
      dispatch(SET_FLYOUT_VERIFIED(ADDITIONAL_USER_INPUTS_PAGE, false, false));
    }
  }
};

function unCheckFlyoutVerification(field: string, productId: number){
  const dependencyFields = {
    'module-selection': [],
    'location-and-loads': locationAndLoadsPageApiFields,
    'rail-system': railSystemPageApiFields,
    'additional-user-inputs': additionalUserInputsPage(productId),
  };

  if (!isAdditionalUserInputEnabledProduct(productId)) {
    delete dependencyFields['additional-user-inputs'];
  } else if (additionalUserInputsPageDependencyFields.includes(field)) {
    dispatch(SET_FLYOUT_VERIFIED('additional-user-inputs', false));
  }

  for (const [key, value] of Object.entries(dependencyFields)) {
    if (value.includes(field)) {
      dispatch(SET_FLYOUT_VERIFIED(key, false));
    }
  }
  return;
}

export const checkSetbackDistanceAffected = (field: string, value: any, currentEnvConfig: projectEnvConfig, resolve: Function) => {

  const { drawingManager: { roofs }, roofsSelector: { mapType }, settings: { panelWidth, panelHeight }, projectConfiguration: { productId, inputUnit, formState: { invalidFields: allInvalidFields }, projectEnvConfig, projectVersion } } = state();

  if (mapType !== 'white') return { isValid: false };

  const invalidFields = new Set<string>();
  RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.map(field => !checkFieldNotEmpty(projectEnvConfig[field]) && invalidFields.add(field));
  allInvalidFields.map(({ fieldName }) => RM_GRIDFLEX_SETBACK_AFFECTING_FIELDS.includes(fieldName) && invalidFields.add(fieldName));
  if (invalidFields.size) return { isValid: false };

  let isValid = false;
  if (field === seismicSsApiField) {
    isValid = checkSeismicSs(value);
  } else if (field === seismicS1ApiField) {
    isValid = checkSeismicS1(value);
  } else if (field === setbackDistanceApiField) {
    isValid = checkSetbackDistance(value, false);
  } else if (field === parapetHeightInputApiField) {
    isValid = checkParapetHeightRmIFIEvo(value, inputUnit, false);
  }

  if (!isValid) return { isValid };

  const newSetbackDistance = getMaxSetBack(currentEnvConfig, inputUnit, productId, projectVersion);

  const anyRoofAffected = roofs && Object.keys(roofs).some(roofId => {
    const { blank_map_building_length: length, blank_map_building_width: width, metersPerPixel, bgScale, panels } = roofs[roofId];

    if (!bgScale) return false;
    const minSizeforMin1Panel = metersToFeets(((newSetbackDistance / metersPerPixel) * 2 + Math.max(panelWidth, panelHeight)) * metersPerPixel);
    const minSize = Math.ceil(minSizeforMin1Panel);
    let [newLength, newWidth] = [length, width];
    if (length < minSize) newLength = minSize;
    if (width < minSize) newWidth = minSize;

    if (length !== newLength || width !== newWidth) {
      dispatch(UPDATE_BLANK_MAP_ROOF_LENGTH_WIDTH_FOR_BLANK_ROOF(Number(roofId), newLength, newWidth));
    }

    const filteredPanels = filterOutPanelsNotInsideRoofEdges({ length: newLength, width: newWidth, setbackDistance: newSetbackDistance, metersPerPixel, bgScale, panelWidth, panelHeight, panels });
    return filteredPanels.length !== panels.length;
  });

  if (!anyRoofAffected) return { isValid: false };

  const onConfirmCallback = () => {
    Object.keys(roofs).map(roofId => {
      const { blank_map_building_length: length, blank_map_building_width: width, metersPerPixel, bgScale, panels } = roofs[roofId];

      const minSizeforMin1Panel = metersToFeets(((newSetbackDistance / metersPerPixel) * 2 + Math.max(panelWidth, panelHeight)) * metersPerPixel);
      const minSize = Math.ceil(minSizeforMin1Panel);
      let [newLength, newWidth] = [length, width];
      if (length < minSize) newLength = minSize;
      if (width < minSize) newWidth = minSize;

      const filteredPanels = filterOutPanelsNotInsideRoofEdges(
        { length: newLength, width: newWidth, setbackDistance: newSetbackDistance, metersPerPixel, bgScale, panelWidth, panelHeight, panels });
      if (filteredPanels.length !== panels.length) {
        dispatch(REPLACE_PANELS_ON_ROOF(filteredPanels, Number(roofId)));
      }
    });
    resolve(true);
  };

  const onCancelCallback = () => resolve(false);
  return { isValid: true, onConfirmCallback, onCancelCallback };
};

export const checkRoofPitchAffected = (field: string, value: any, currentEnvConfig: projectEnvConfig, resolve: Function) => {
  let shouldShowClearRoofsModal = false;
  let roofPitchLimit = 7;
  const { projectConfiguration: { seismicDesignCategory, area: areaAddress, projectEnvConfig: { allow_mechanical_attachments, } , projectVersion}, drawingManager: { roofs } } = state();
  if (isASCE716or722(currentEnvConfig.building_code) && SDC_AFFECTING_FIELDS.includes(field)) {
    let isValid = false;
    if (field === seismicSsApiField) {
      isValid = checkSeismicSs(value);
    } else if (field === seismicS1ApiField) {
      isValid = checkSeismicS1(value);
    } else {
      isValid = checkFieldNotEmpty(value);
    }

    if (!isValid) return { isValid };

    const { seismicDesignCategory: updatedSeismicDesignCategory } = getSeismicDesignCategory(currentEnvConfig);
    if (seismicDesignCategory !== updatedSeismicDesignCategory) {
      dispatch(SET_SEISMIC_DESIGN_CATEGORY(updatedSeismicDesignCategory));
    }
    shouldShowClearRoofsModal = RESTRICTED_ROOF_PITCH_SDC_VALUES.includes(updatedSeismicDesignCategory) &&
      !RESTRICTED_ROOF_PITCH_SDC_VALUES.includes(seismicDesignCategory);
  } else if (isASCE710(currentEnvConfig.building_code)) {
    const stateString = areaAddress.split(',')[1];
    shouldShowClearRoofsModal = [buildingCodeApiField, 'zipCode'].includes(field) && stateString && stateString.trim() === 'CA';
  }

  if (shouldShowClearRoofsModal) {
    roofPitchLimit = 3;
  } else if (currentEnvConfig.allow_mechanical_attachments && (currentEnvConfig.attachment_type === AttachmentType.UNIRAC_FLASHLOC_RM || currentEnvConfig.allow_mechanical_attachments !== allow_mechanical_attachments)) {
    shouldShowClearRoofsModal = true;
    roofPitchLimit = 5;
  }

  const anyRoofPitchExceedsLimit = roofs && Object.keys(roofs).some(roofId => {
    const roofPitch = roofs[roofId]?.roofPitch;
    return roofPitch && Number(roofPitch) > roofPitchLimit;
  });

  shouldShowClearRoofsModal = shouldShowClearRoofsModal && anyRoofPitchExceedsLimit;

  if (!shouldShowClearRoofsModal) return { isValid: false };

  const onConfirmCallback = () => {
    Object.keys(roofs).map(roofId => {
      if (Number(roofs[roofId].roofPitch) > roofPitchLimit) {
        makeRoofEmpty(Number(roofId));
        const min_pitch_val = greaterThanEqualToProjectVersion(projectVersion, VERSION_MAP['default_roofpitch_value_changes']) ? "1" : "0";
        dispatch(SET_ROOF_ROOF_PITCH(Number(roofId), min_pitch_val));
      }
    });
    resolve(true);
  };

  const onCancelCallback = () => resolve(false);
  return { isValid: true, projectVersion, onConfirmCallback, onCancelCallback ,};
};

export const checkManualAttachmentsAffected = (field: string, value: any, currentEnvConfig: projectEnvConfig, resolve: Function) => {
  const { projectConfiguration: { projectEnvConfig: { allow_mechanical_attachments }, productId } } = state();
  let isValid = false;
  if (field === allowMechanicalAttachmentsApiField && !currentEnvConfig.allow_mechanical_attachments && currentEnvConfig.allow_manual_attachments && currentEnvConfig.allow_mechanical_attachments !== allow_mechanical_attachments) {
    isValid = anyRoofHasManualAttachments(0);
  }
  if (!isValid) return { isValid };
  const onConfirmCallback = () => {
    dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField, 0));
    deleteManualAttachmentsOnPanels(productId);
    resolve(true);
  };
  const onCancelCallback = () => resolve(false);
  return { isValid, onConfirmCallback, onCancelCallback };
}

export const getRMIFICheckPromise = (field: string, value: any, productId: number, prevEnvConfig: projectEnvConfig): Promise<boolean> => {
  // Promise resolves to :
  // 1. True: if Project Option Update should continue
  // 2. False: if Project Option shouldn't update   
  return new Promise((resolve, _) => {
    if ((!isRMIFIProduct(productId) && !isRM10Evolution(productId) && !isRM5(productId)) || prevEnvConfig[field] === value) {
      return resolve(true);
    }
    let currentEnvConfig = { ...prevEnvConfig, [field]: value };
    if (field === buildingCodeApiField && isASCE710(value) && prevEnvConfig[soilClassApiField] === SOIL_CLASS.D_DEFAULT) {
      currentEnvConfig = { ...currentEnvConfig, [soilClassApiField]: SOIL_CLASS.D };
    }

    const { isValid: roofPitchAffected, projectVersion: projectVersion, onConfirmCallback: onConfirmCallbackRoofPitch, onCancelCallback: onCancelCallbackRoofPitch } = checkRoofPitchAffected(field, value, currentEnvConfig, resolve);
    if (roofPitchAffected) {
      const min_pitch_val = greaterThanEqualToProjectVersion(projectVersion, VERSION_MAP['default_roofpitch_value_changes']) ? "1" : "0";
      const warning_message = field === attachmentTypeApiField && value === AttachmentType.UNIRAC_FLASHLOC_RM ?
        'Modifying the "ATTACHMENT TYPE" field value to Unirac Flashloc RM will reset your Roof pitch to '+min_pitch_val+' and clear out your Roof Area(s) panels if any, as maximum allowable roof pitch for Unirac flashloc RM is 5. Continue?' :
        `Modifying the "${field.toLocaleUpperCase().replace(/_/g, ' ')}" field value will reset your Roof Pitch to `+min_pitch_val+` and clear out your Roof Area(s) panels if any. Continue?`;
      dispatch(OPEN_DRAWER_PAGE(null));
      dispatch(
        OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
          'Roof Pitch will be reset!',
          warning_message,
          onConfirmCallbackRoofPitch,
          onCancelCallbackRoofPitch,
        ),
      );
      return;
    }
    const { isValid: setbackDistanceAffected, onConfirmCallback: onConfirmCallbackSetback, onCancelCallback: onCancelCallbackSetback } = checkSetbackDistanceAffected(field, value, currentEnvConfig, resolve);
    if (setbackDistanceAffected) {
      dispatch(OPEN_DRAWER_PAGE(null));
      dispatch(
        OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
          'Setback Distance Increased!',
          `Modifying the ${field} field value will adjust the setback distance and remove some of the panels in your Roof Area(s). Continue?`,
          onConfirmCallbackSetback,
          onCancelCallbackSetback,
        ),
      );
    }
    const { isValid: manualAttachmentsAffected, onConfirmCallback: onConfirmCallbackManualAttachments, onCancelCallback: onCancelCallbackManualAttachments } = checkManualAttachmentsAffected(field, value, currentEnvConfig, resolve);
    if (manualAttachmentsAffected) {
      dispatch(OPEN_DRAWER_PAGE(null));
      dispatch(
        OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
          'Are you sure you want to disallow mechanical attachments?',
          'All manual attachment markers will be lost!',
          onConfirmCallbackManualAttachments,
          onCancelCallbackManualAttachments,
        ),
      );
    } else resolve(true);
  });
};


export const updateProjectOption = (
  field: string,
  value: any,
  zipcode: string,
  productId: number,
  currentEnvConfig: projectEnvConfig,
) => {
  const canonicalValue = getCanonicalS5OptionValue(field, value, currentEnvConfig);
  const isS5Field = [s5RoofManufacturerTypeField, s5RoofPanelTypeField, s5RoofMaterialTypeField, s5ClampTypeField].includes(field);

  if (isS5Field && canonicalValue !== currentEnvConfig[field]) {
    dispatch(SET_PROJECT_OPTION(field, canonicalValue));
  }

  // if update was discarded by user, dont update the project option
  return getRMIFICheckPromise(field, canonicalValue, productId, currentEnvConfig)
    .then(allowUpdate => {
      if (allowUpdate) applyProjectOptionUpdate(field, canonicalValue, zipcode, productId, currentEnvConfig);
    })
    .then(() => disableFlyoutsVerified(field, productId));
};

function getCanonicalS5OptionValue(field: string, value: any, currentEnvConfig: projectEnvConfig) {
  if (!value) {
    return value;
  }

  if (field === s5RoofManufacturerTypeField) {
    return getS5DataValue(s5AttachmentsData, s5AttachmentDictKeys.s_5_roof_manufacturer, value);
  }

  if (field === s5RoofPanelTypeField) {
    const { s5_roof_manufacturer } = currentEnvConfig;
    const s5RoofPanelTypeData = filterDataByFields(
      s5AttachmentsData,
      (s5_roof_manufacturer === isGeneric) ? '' : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : s5_roof_manufacturer},
    );

    return getS5DataValue(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type, value);
  }

  if (field === s5RoofMaterialTypeField) {
    const { s5_roof_manufacturer, s5_roof_panel } = currentEnvConfig;
    const s5RoofMaterialData = filterDataByFields(
      s5AttachmentsData,
      (s5_roof_panel === isGeneric) ? '' : {
        [s5AttachmentDictKeys.s_5_roof_manufacturer]: s5_roof_manufacturer,
        [s5AttachmentDictKeys.s_5_roof_panel_type]: s5_roof_panel,
      },
    );

    return getS5DataValue(s5RoofMaterialData, s5AttachmentDictKeys.s_5_roof_material, value);
  }

  return value;
}

function updateNon716Panels(productId: number) {
  const { roofsSelector: { mapType }, projectConfiguration: { projectEnvConfig: { building_type }, projectVersion } } = state();
  const roofs = getProjectRoofs();

  if (roofs) {
    const editorCenter = getEditorCenter();
    const buildingHeightFt = getBuildingHeight();

    Object.keys(roofs).forEach(roofKey => {
      const roofId = Number(roofKey);
      const roof: drawingManagerRoof = roofs[roofId];
      const panels = roof.panels;
      const rowSpacing = roof.rowSpacing;
      const { columnSpacing } = getSpacings(productId, projectVersion);


      if (!panels || panels.length === 0) {
        return;
      }

      const metersPerPixel = roof.metersPerPixel;

      recalculateRoofZonesForPanels(
        store,
        panels,
        roof,
        mapType,
        productId,
        editorCenter,
        buildingHeightFt,
        building_type,
        projectVersion,
      ).then((panelsWithReassignedZones) => {
        let updatedPanels = removePanelsWithNoSiblings(panelsWithReassignedZones);
        updatedPanels = checkObstructionZoneForPanels(updatedPanels, roofId, metersPerPixel, editorCenter.x, editorCenter.y);
        clearRTree();

        updatedPanels.map(panel => {
          const bounds = getPanelCollisionBounds(panel, rowSpacing, columnSpacing, metersPerPixel);
          insertPanelIntoRtree(bounds);
        });
        dispatch(REPLACE_PANELS_ON_ROOF(updatedPanels, roofId));
      });

    });
  }
}

export const applyProjectOptionUpdate = (
  field: string,
  value: any,
  zipcode: string,
  productId: number,
  currentEnvConfig: projectEnvConfig,
) => {
  const previousEnvConfig = {
    ...currentEnvConfig,
  };
  const { user: { isStaff, permissions }, projectConfiguration: { inputUnit, projectVersion, railsProductId, projectEnvConfig: { rail_arrangement_type, elevation: elevation_value, wind_exposure, building_height, nbcc_roughness, max_block_count, min_block_count, interior_bay_capacity, is_half_block_allowed, blocks_orientation, attachment_optimization_criteria, is_domestic_mlpe_required, domestic_content} }, moduleSelector: { modelData: { height: moduleLength } }, drawingManager:{roofs}, roofsSelector: { mapType } } = state();
  const isCanadianZipcode = checkCanadianZipcode(zipcode);
  unselectRadioOption(value);

  const resetClampsToStandard = (apiFields: string[], modalMessage: string, onCancel?: () => void) => {
    const clampNeedsReset = apiFields.some(f => currentEnvConfig[f] !== smClampsOptions.standardClamps.value);
    if (!clampNeedsReset) return;
    const resetClamps = () => apiFields.forEach(f => dispatch(SET_PROJECT_OPTION(f, smClampsOptions.standardClamps.value)));
    if (anyPanelsDrawn()) {
      dispatch(OPEN_DRAWER_PAGE(null));
      dispatch(OPEN_CONFIRM_CLEAR_ARRAYS_MODAL('Clamps will be changed!', modalMessage, () => { resetClamps(); makeAllRoofsEmpty(); }, onCancel || null));
    } else {
      resetClamps();
    }
  };

  const isDomesticContentYES = (field === isDomesticMLPERequiredField || field === domesticContentField) ? value === 1 : (is_domestic_mlpe_required === 1 || domestic_content === 1);

  if (applySMDomesticContentClampFilter(projectVersion) && isDomesticContentYES) {
    if ((isSMRegular(productId) || isSMLT(productId)) && !isSMAscenderFlush(railsProductId) && (field === isDomesticMLPERequiredField || field === domesticContentField)) {
      resetClampsToStandard([midClampsApiField, endClampsApiField], 'Selecting "YES" for Domestic Content will change Mid and End Clamps to Standard Clamps and clear all Roof Area panels. Continue?', () => dispatch(SET_PROJECT_OPTION(field, previousEnvConfig[field])));
    }
    else if (isSMTiltPR(productId) && !isSMTiltPRWithAscender(railsProductId) && (field === isDomesticMLPERequiredField || field === domesticContentField)) {
      resetClampsToStandard([midClampsApiField, endClampsApiField], 'Selecting "YES" for Domestic Content will change Mid and End Clamps to Standard Clamps and clear all Roof Area panels. Continue?', () => dispatch(SET_PROJECT_OPTION(field, previousEnvConfig[field])));
    }
    else if (isSMTilt(productId) && !isNxtTilt(productId) && (field === isDomesticMLPERequiredField || field === domesticContentField)) {
      resetClampsToStandard([smClampsChoicesApiField], 'Selecting "YES" for Domestic Content will change Clamps to Standard Clamps and clear all Roof Area panels. Continue?', () => dispatch(SET_PROJECT_OPTION(field, previousEnvConfig[field])));
    }
  }

  clearActiveCheckboxes();
  addActiveCheckbox(field, currentEnvConfig[field]);
  unCheckFlyoutVerification(field, productId)
  if((isRM10orRM10Evo(productId) || isRMGridFlex(productId) || isEcoFoot2Plus(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) || isRM5(productId)) 
  && greaterThanEqualToProjectVersion(projectVersion, VERSION_MAP['changing_soil_class_to_d_default_for_building_code_asce_716'])){      
    if(field === buildingCodeApiField){
      if(isASCE716or722(value)){
        dispatch(SET_PROJECT_OPTION(soilClassApiField, SOIL_CLASS.D_DEFAULT));
      }
      else {
        dispatch(SET_PROJECT_OPTION(soilClassApiField, SOIL_CLASS.D));
      }
    }
  }

  if (field === elevation.apiField || field === windSpeedApiField || (field === buildingHeightApiField) && !isAscender(productId)) {
    dispatch(SET_PROJECT_OPTION(field, parseInt(value, 10).toFixed(0)));
  }
  else if (field === AdjustableTiltSystem.apiField) {
    (anyPanelsDrawn()) ? 
    dispatch(OPEN_CONFIRM_CLEAR_ARRAYS_MODAL(
      'Change adjustable tilt',
      'Changing adjustable tilt will remove all panels. Are you sure?',
      () => {
        makeAllRoofsEmpty();
        productChange(field, value);
      },
      null,
    )) : productChange(field, value);
  }
  else if (field === staggerAttachments.apiField || field === roundingHalfBlock.apiField) {
    let val: boolean;

    if (value === 'false') {
      val = false;
    } else {
      val = true;
    }
    dispatch(SET_PROJECT_OPTION(field, val));
    if (field === roundingHalfBlock.apiField) {
      if (isAdditionalUserInputEnabledProduct(productId) && isStaff ) {
        const rm5MaxBlockMax = rm5MaxBlockCount(isHalfBlockAllowed(val));
        const interiorBayMax = interiorBayCapacity(productId, isHalfBlockAllowed(val));
        const minBlockMax = minBlockCount(attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(val), productId);
        dispatch(SET_PROJECT_OPTION(interiorBayCapacityApiField, interiorBayMax));
        dispatch(SET_PROJECT_OPTION(minBlockCountApiField, minBlockMax));
        if(isRM5(productId)){
          dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, rm5MaxBlockMax))
        }else if(isRmGridflex10D(productId)){
          dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, rmGridflex10MaxBlockCount(isHalfBlockAllowed(val), blocks_orientation)))
        }else if(isRmGridflex5Rwdi(productId)){
          dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, rmGridflex5dMaxBlockCount(isHalfBlockAllowed(val), moduleLength)))
        }
      }
    }
  }
  else if ([roofPsfLimitApiField, shearAllowableApiField, upliftAllowableApiField, ballastBlockHalfWeightApiField, ballastBlockWeightApiField, rainLoadApiField].includes(field)) {
    if (value.toString().split('.').length > 1 && value.toString().split('.')[1].length > 1) {
      dispatch(SET_PROJECT_OPTION(field, parseFloat(value).toFixed(1)));
    } else {
      dispatch(SET_PROJECT_OPTION(field, value));
    }
  }
  else if (field === totalWeightOnRoofLimitApiField) {
    dispatch(SET_PROJECT_OPTION(field, parseInt(value, 10)));
  }
  else if (field === setbackDistanceApiField) {
    if (isRM10orRM10Evo(productId) || isEcoFoot2Plus(productId) || isRM5(productId) || isRMGridFlex(productId)) {
      dispatch(SET_PROJECT_OPTION(field, parseFloat(value.toFixed(1))));
    } else {
      dispatch(SET_PROJECT_OPTION(field, parseInt(value, 10)));
    }
  } else if ((isRMGridFlex(productId) || isRM10(productId) || isRM10Evolution(productId)) && field === deadLoadFactorApiField) {
    if (value.toString().split('.').length > 1 && value.toString().split('.')[1].length > 3) {
      dispatch(SET_PROJECT_OPTION(field, parseFloat(value).toFixed(3)));
    } else {
      dispatch(SET_PROJECT_OPTION(field, value));
    }
  } else if (field === centralSupportApiField && isBoolean(value)) {
    if (isRM10(productId) || isRM10Evolution(productId) || isRM5(productId)) {
      if (isMetricUnit(inputUnit)) {
        if (!permissions.includes(MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION) && (moduleLength > inchesToCms(87) && previousEnvConfig.snow_load > psfToKpa(20) || previousEnvConfig.snow_load > psfToKpa(60) || moduleLength > inchesToCms(90))) {
          return showErrorAlert(`Central support is required for module length > ${inchesToCms(87)}cm and snow load > ${psfToKpa(20)}kpa or snow load > ${psfToKpa(60)}kpa or module length > ${inchesToCms(90)}cm.`);
        }
      }
      if (!permissions.includes(MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION) && (checkCentralSupportConditionForSnowloadAndHeight(previousEnvConfig.snow_load, store.getState().moduleSelector.modelData.height))) {
        return showErrorAlert('Central support is required for module length >= 87in and snow load > 20psf or snow load > 60psf or module length >= 90in.');
      }
    }
    else if(isEcoFoot2Plus(productId)){
      if(permissions.includes(MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION)){
        dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
      } else if(disableMandatoryMidSupportCondition(store.getState().moduleSelector.modelData.height,previousEnvConfig.snow_load) && !permissions.includes(MANDATORY_CENTRAL_SUPPORT_ACCESS_PERMISSION)){
        return showErrorAlert('Central support is required for module length <= 68in and snow load >= 50psf or module length between 68-87in and snow load >= 40psf or module length >= 87in and snow load >= 20psf or module length >= 90in.');
      }     
    }
    dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
  }
  else if (field === useFriction && isBoolean(value)) {
    dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
    if (!value) {
      dispatch(SET_PROJECT_OPTION(addRoofPadsEverywhere, 0));
    }
  }
  else if (field === addRoofPadsEverywhere && isBoolean(value) && useFriction) 
  {
    dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
  }
  else if (field === mandatorymidsupportApiField && isBoolean(value)) {
    dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
  }
  else if (field === useDefaultFlatSlopeRoofSnowLoadApiField && isBoolean(value)) {
    dispatch(SET_PROJECT_OPTION(field, value ? 1 : 0));
    if (!value) {
      if (currentEnvConfig[thermalFactorApiField] == null) {
        dispatch(SET_PROJECT_OPTION(thermalFactorApiField, isASCE722(currentEnvConfig[buildingCodeApiField]) ? 1.2 : 1));
      }
      const groundSnowLoad = currentEnvConfig[snowLoadApiField];
      dispatch(SET_PROJECT_OPTION(flatRoofSnowLoadApiField, groundSnowLoad));
    } else {
      dispatch(SET_PROJECT_OPTION(flatRoofSnowLoadApiField, null));
    }
  }
  else if (field == snowLoadApiField) {
    if (isAscender(productId) || isMetricUnit(inputUnit)) {
      if (value.toString().split('.').length > 1 && value.toString().split('.')[1].length > 2) {
        dispatch(SET_PROJECT_OPTION(field, parseFloat(value).toFixed(2)));
      } else {
        dispatch(SET_PROJECT_OPTION(field, value));
      }
    }
    else {
      dispatch(SET_PROJECT_OPTION(field, parseInt(String(value))));
    }
    if (currentEnvConfig[useDefaultFlatSlopeRoofSnowLoadApiField] == 0) {
      dispatch(SET_PROJECT_OPTION(flatRoofSnowLoadApiField,
        store.getState().projectConfiguration.projectEnvConfig[snowLoadApiField]));
    }
  }
  else if (field === residentalBuildingTypes.apiField) {
    setProperRoofPitchForResidentialsASCE716(currentEnvConfig.building_code, value);
  }
  else if (field === railLengthForThermalGap.apiField && !value) {
    dispatch(SET_FIELD_INVALID(railLengthForThermalGap.apiField, `Rail Length for each thermal gap must be selected`));
  }
  else if (field === seismicSsApiField) {
    dispatch(CLEAR_INVALID_FIELD(seismicSsApiField));
    dispatch(SET_PROJECT_OPTION(seismicSsApiField, parseFloat(value.toFixed(3))));
    if (value <= 0 || value > 3.1) {
      dispatch(SET_FIELD_INVALID(seismicSsApiField, 'Seismic Factor(SS) must be a positive value not exceeding 3.1'));
    }
  }
  else if (field === seismicS1ApiField) {
    dispatch(CLEAR_INVALID_FIELD(seismicS1ApiField));
    dispatch(SET_PROJECT_OPTION(seismicS1ApiField, parseFloat(value.toFixed(3))));
    if (value < 0 || value > 3.1) {
      dispatch(SET_FIELD_INVALID(seismicS1ApiField, 'Seismic Factor(S1) must lie between 0 and 3.1'));
    }
  }
  else if (field === seismicSds.apiField) {
    dispatch(CLEAR_INVALID_FIELD(seismicSds.apiField));
    dispatch(SET_PROJECT_OPTION(seismicSds.apiField, parseFloat(value.toFixed(3))));
    if (value < seismicSds.min || value > seismicSds.max) {
      dispatch(SET_FIELD_INVALID(seismicSds.apiField, `Seismic Factor(Sds) must lie between ${seismicSds.min} and ${seismicSds.max}`));
    }
  }
  else if (field === seismicSd1.apiField) {
    dispatch(CLEAR_INVALID_FIELD(seismicSd1.apiField));
    dispatch(SET_PROJECT_OPTION(seismicSd1.apiField, parseFloat(value.toFixed(3))));
    if (value < seismicSd1.min || value > seismicSd1.max) {
      dispatch(SET_FIELD_INVALID(seismicSd1.apiField, `Seismic Factor(Sd1) must lie between ${seismicSd1.min} and ${seismicSd1.max}`));
    }
  }
  else if (field === tornadoSpeed.apiField) {
    const { apiField, min, max } = isMetricUnit(inputUnit) ? metricTornadoSpeedField : tornadoSpeed;
    dispatch(CLEAR_INVALID_FIELD(apiField));
    dispatch(SET_PROJECT_OPTION(apiField, parseFloat(value.toFixed(3))));
    if (value < min || value > max) {
      dispatch(SET_FIELD_INVALID(apiField, `Tornado Speed must lie between ${min} and ${max}`));
    }
  }
  else if (field === longTransitionPeriods.apiField) {
    const { apiField, min, max } = longTransitionPeriods;
    dispatch(CLEAR_INVALID_FIELD(apiField));
    dispatch(SET_PROJECT_OPTION(apiField, parseInt(value)));
    if (value < min || value > max) {
      dispatch(SET_FIELD_INVALID(apiField, `Long-Period Transition Periods must lie between ${min} and ${max}`));
    }
  }
  else if (field === longestRowLength.apiField) {
    const { apiField, min, max } = longestRowLength;
    dispatch(CLEAR_INVALID_FIELD(apiField));
    dispatch(SET_PROJECT_OPTION(apiField, parseFloat(value)));
    if (value < min || value > max) {
      dispatch(SET_FIELD_INVALID(apiField, `Longest Row Length must lie between ${min} and ${max}`));
    }
  }
  else if (field === shortestRowLength.apiField) {
    const { apiField, min, max } = shortestRowLength;
    dispatch(CLEAR_INVALID_FIELD(apiField));
    dispatch(SET_PROJECT_OPTION(apiField, parseFloat(value)));
    if (value < min || value > max) {
      dispatch(SET_FIELD_INVALID(apiField, `Shortest Row Length must lie between ${min} and ${max}`));
    }
  }
  else if (field === nbccWindPressureApiField) {
    dispatch(CLEAR_INVALID_FIELD(nbccWindPressureApiField));
    dispatch(SET_PROJECT_OPTION(nbccWindPressureApiField, parseFloat(value.toFixed(2))));
    if (value < nbccWindPressure.min || value > nbccWindPressure.max) {
      dispatch(SET_FIELD_INVALID(nbccWindPressureApiField, `Wind Pressure must lie between ${nbccWindPressure.min} and ${nbccWindPressure.max}`));
    }
  }
  else if ([velocityPressureExposureCofficientKzApiField, groundElevationFactorKeApiField, windDirectionalityFactorKdApiField,
    rmTopographicalFactorKztApiField, numericalCoefficientApiField, designLifeFactorFcApiField].includes(field)) {    
    dispatch(SET_PROJECT_OPTION(field, parseNumberFromText(value)));
  }
  else if (field == 'zipcode') {
    dispatch(SET_PROJECT_OPTION(field, value));
    if(isRM10orRM10Evo(productId) || isEcoFoot2Plus(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) || isRM5(productId)) {
      dispatch(SET_PROJECT_OPTION(velocityPressureExposureCofficientKzApiField, calculateKz(wind_exposure, building_height, value, projectVersion, inputUnit, nbcc_roughness, isCanadianChangesProduct(productId), currentEnvConfig.building_code)));
      dispatch(SET_PROJECT_OPTION(groundElevationFactorKeApiField, calculateKe(elevation_value, isASCE716or722(currentEnvConfig.building_code), inputUnit, projectVersion, zipcode)));
      dispatch(SET_PROJECT_OPTION(numericalCoefficientApiField, get_numerical_coefficient(currentEnvConfig.building_code, elevation_value, inputUnit, zipcode, projectVersion) ));
    }
  }
  else {
    dispatch(SET_PROJECT_OPTION(field, value));
  }

  let northBayOrMaxBlock;
    if(isRM10Evolution(productId) || isEcoFoot2Plus(productId)){
      northBayOrMaxBlock = 'North Bay Capacity'
    }else if(isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)){
      northBayOrMaxBlock = 'Max Block Count'
    }

  if(field === attachmentOptimizationCriteriaApiField){
    if (isAdditionalUserInputEnabledProduct(productId) && isStaff ) {
      if(value === AttachmentOptimization.FULLY_ATTACHED){4
        const minBlock = minBlockCount(value === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(is_half_block_allowed), productId);
        dispatch(SET_PROJECT_OPTION(minBlockCountApiField, minBlock));
        if(minBlock >= max_block_count){
          dispatch(SET_FIELD_INVALID(maxBlockCountApiField, `${northBayOrMaxBlock} must greater than min block count`));
        }
        if(isRM10Evolution(productId) && minBlock >= interior_bay_capacity){
          dispatch(SET_FIELD_INVALID(interiorBayCapacityApiField, `Interior bay capacity must greater than min block count`));
        }

      }
    }
  }

  if (field === allowThermalGap.apiField) {
    if (value === 0) {
      dispatch(SET_PROJECT_OPTION(railLengthForThermalGap.apiField, null));
    }
    else {
      dispatch(SET_FIELD_INVALID(railLengthForThermalGap.apiField, `Rail Length for each thermal gap must be selected`));
    }
  }
  if (isRMGridFlex(productId) && field===snowLoadApiField){
    dispatch(SET_PROJECT_OPTION(mandatorymidsupportApiField, disableMandatoryMidSupportCondition(store.getState().moduleSelector.modelData.height, value)));
  }

  if ((isResidentialProduct(productId) || isRMFamily(productId) || isEcoFoot2Plus(productId) || isGroundProduct(productId)) && field === buildingCode.apiField) {
    if(!isGroundProduct(productId)) {
      if (isASCE716or722BuildingCode(value)) {
        dispatch(SET_PROJECT_OPTION('mean_recurrence_interval', '50'));
        dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(50)));
        setResidentialsExtraInputsValueForAsce716(productId);
      } else {
        !isCanadianZipcode && dispatch(SET_PROJECT_OPTION('mean_recurrence_interval', '25'));
        !isCanadianZipcode && dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(25)));
        unsetResidentialsExtraInputsValueForAsce716(productId);
      }
    }
    if(isASCE722BuildingCode(value)) {
      setExtraInputsValueForAsce722();
    }
    else {
      unsetExtraInputsValueForAsce722();
    }

    if(isEcoFoot2Plus(productId) && applyRemoveMRI25ForEF(projectVersion)){
      dispatch(SET_PROJECT_OPTION('mean_recurrence_interval', '50'));
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(50)));
    }
  }
  
  if (isAdditionalUserInputEnabledProduct(productId) && isStaff ) {
    if (field === windExposureApiField && value !== previousEnvConfig[windExposureApiField]) {
      dispatch(SET_PROJECT_OPTION(velocityPressureExposureCofficientKzApiField, calculateKz(value, previousEnvConfig[buildingHeightApiField], zipcode, projectVersion, inputUnit, previousEnvConfig[nbccRoughnessApiField], isCanadianChangesProduct(productId), previousEnvConfig.building_code)));
    }
    if (field === buildingHeightApiField && value !== previousEnvConfig[buildingHeightApiField]) {
      dispatch(SET_PROJECT_OPTION(velocityPressureExposureCofficientKzApiField, calculateKz(previousEnvConfig[windExposureApiField], value, zipcode, projectVersion, inputUnit, previousEnvConfig[nbccRoughnessApiField], isCanadianChangesProduct(productId), previousEnvConfig.building_code)));
    }
    if (field === nbccRoughnessApiField && value !== previousEnvConfig[nbccRoughnessApiField]) {
      dispatch(SET_PROJECT_OPTION(velocityPressureExposureCofficientKzApiField, calculateKz(previousEnvConfig[windExposureApiField], previousEnvConfig[buildingHeightApiField], zipcode, projectVersion, inputUnit, value, isCanadianChangesProduct(productId), previousEnvConfig.building_code)));
    }
    if (field === elevation.apiField && value !== previousEnvConfig[elevation.apiField]) {
      dispatch(SET_PROJECT_OPTION(groundElevationFactorKeApiField, calculateKe(value, isASCE716or722(previousEnvConfig[buildingCodeApiField]), inputUnit, projectVersion, zipcode)));
      dispatch(SET_PROJECT_OPTION(numericalCoefficient.apiField, get_numerical_coefficient(previousEnvConfig[buildingCodeApiField], value, inputUnit, zipcode, projectVersion)));
    }
    if (field === buildingCodeApiField && value !== previousEnvConfig[buildingCodeApiField]) {
      dispatch(SET_PROJECT_OPTION(velocityPressureExposureCofficientKzApiField, calculateKz(previousEnvConfig[windExposureApiField], previousEnvConfig[buildingHeightApiField], zipcode, projectVersion, inputUnit, previousEnvConfig[nbccRoughnessApiField], isCanadianChangesProduct(productId), currentEnvConfig.building_code)));
      dispatch(SET_PROJECT_OPTION(groundElevationFactorKeApiField, calculateKe(previousEnvConfig[elevation.apiField], isASCE716or722(value), inputUnit)));
      dispatch(SET_PROJECT_OPTION(numericalCoefficient.apiField, get_numerical_coefficient(value, previousEnvConfig[elevation.apiField], inputUnit, zipcode, projectVersion)));
      dispatch(SET_PROJECT_OPTION(thermalFactorApiField, isASCE722(value)?1.2:1));
    }
    if (field === designLifeFactorFc.apiField && value !== previousEnvConfig[designLifeFactorFc.apiField]) {
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, parseNumberFromText(value)));
    }
    if (field === meanRecurrenceInterval.apiField && value !== previousEnvConfig[meanRecurrenceInterval.apiField]) {
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(value)));
    }

    if (field === frictionFactorApiField) {
      const { min, max } = getLimitsOfFrictionCoefficient(productId);
      dispatch(SET_PROJECT_OPTION(frictionFactorApiField, parseFloat(value.toFixed(2)) > max ? max : parseFloat(value.toFixed(1))));
      if (value < min || value > max) {
        dispatch(SET_FIELD_INVALID(frictionFactorApiField, `Coefficient Of Friction must lie between ${min} and ${max}`));
      }
    }

    if (field === maxBlockCountApiField){
      maxBlockCountFieldValidations(value, min_block_count)
    }
    if (field === maxBlockNorthCornerCountApiField){
      maxBlockNorthCornerCountFieldValidations(value, min_block_count, moduleLength)
    }

    if (field === minBlockCountApiField){
      minBlockCountFieldValidations(value)
      maxBlockCountFieldValidations(max_block_count, value)
      interiorBlockCountFieldValidations(interior_bay_capacity, value)
    }

    if (field === interiorBayCapacityApiField){
      interiorBlockCountFieldValidations(value, min_block_count)
    }
    
    if (field === thermalFactorApiField) {
      const { min, max } = thermalFactor;
      dispatch(SET_PROJECT_OPTION(thermalFactorApiField, parseFloat(value.toFixed(1))));
      if (value < min || value > max) {
        dispatch(SET_FIELD_INVALID(thermalFactorApiField, `Thermal Factor must lie between ${min} and ${max}`));
      }
    }
    if (field === flatRoofSnowLoadApiField) {
      const { lowerLimit, upperLimit } = getSnowLoadLimits();
      if (value < lowerLimit || value > upperLimit) {
        dispatch(SET_FIELD_INVALID(field, `Snow load must lie between ${lowerLimit} and ${upperLimit}.`));
      }
    }

    function maxBlockCountFieldValidations(value, checkingValue){
      const allowDecimal = isHalfBlockAllowed(is_half_block_allowed) ? true : false;
      const min = 0.5
      const max = isRM5(productId)  ? rm5MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed)) : isRmGridflex10D(productId) ? rmGridflex10MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed),blocks_orientation ) : isRmGridflex5Rwdi(productId) ? 5 : MAX_BLOCK_COUNTS[productId];
      const decimalValue = value.toString().split('.')
      const roundingValue = Number(parseInt(value, 10).toFixed(0));
      if(value <= checkingValue){
        dispatch(SET_FIELD_INVALID(maxBlockCountApiField, `${northBayOrMaxBlock} must greater than min block count`));
      } 
      else if (value < min || value > max) {
        dispatch(SET_FIELD_INVALID(maxBlockCountApiField, `${northBayOrMaxBlock} must less than ${max+( (isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) ? 1 : allowDecimal ? 0.5 : 1)}`));
      } 
      else if (decimalValue.length > 0 && allowDecimal ) {
        if((decimalValue[1].length > 0 && decimalValue[1].length < 2) && ["0", "5"].includes(decimalValue[1])){
            dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, Number(value)));
          }
          else{
            dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, roundingValue));
            if(roundingValue <= checkingValue){
              dispatch(SET_FIELD_INVALID(maxBlockCountApiField, `${northBayOrMaxBlock} must greater than min block count`));
            } 
          }
      } else {
        dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, roundingValue));
      }
    }
    function maxBlockNorthCornerCountFieldValidations(value, checkingValue, length){
      const allowDecimal = isHalfBlockAllowed(is_half_block_allowed) ? true : false;
      const min = 0.5
      const max =  isRmGridflex10D(productId) ? rmGridflex10MaxBlockNorthCornerCount(isHalfBlockAllowed(is_half_block_allowed), length ) : MAX_BLOCK_COUNTS[productId];
      const decimalValue = value.toString().split('.')
      const roundingValue = Number(parseInt(value, 10).toFixed(0));
      if (value > max) {
        dispatch(SET_FIELD_INVALID(maxBlockNorthCornerCountApiField, `${northBayOrMaxBlock} must less than ${max+(allowDecimal ? 0.5 : 1)}`));
      }  else {
        dispatch(SET_PROJECT_OPTION(maxBlockNorthCornerCountApiField, roundingValue));
      }
    }
    function minBlockCountFieldValidations(value){
      const min = 0
      const allowDecimal = isHalfBlockAllowed(is_half_block_allowed) ? true : false;
      const maxBlocksCountMaxValue = isRM5(productId)  ? rm5MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed)) : isRmGridflex10D(productId) ? rmGridflex10MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed),blocks_orientation ) : isRmGridflex5Rwdi(productId) ? 5 : MAX_BLOCK_COUNTS[productId];
      const maxInteriorCapacityMaxValue = interiorBayCapacity(productId, isHalfBlockAllowed(is_half_block_allowed));
      const maxCapacity = (maxBlocksCountMaxValue > maxInteriorCapacityMaxValue) ? maxInteriorCapacityMaxValue : maxBlocksCountMaxValue;
      const maxValue = (max_block_count > interior_bay_capacity) ? interior_bay_capacity : max_block_count;
      const maxValueField = (maxBlocksCountMaxValue > maxInteriorCapacityMaxValue) ? 'Interior bay capacity' : 'Max block count'
      const max = maxValue > 0 ? maxValue - (allowDecimal ? 0.5 : 1 ): maxValue;
      const decimalValue = value.toString().split('.')
      const roundingValue = allowDecimal ? value : Number(parseInt(value, 10).toFixed(0));
      if (roundingValue < min || roundingValue >= maxCapacity) {
        dispatch(SET_FIELD_INVALID(minBlockCountApiField, `Min block count must less than  ${maxCapacity}`));
      }
      else if (roundingValue < min || roundingValue > max) {
        dispatch(SET_FIELD_INVALID(minBlockCountApiField, `Min block count must less than  ${maxValueField}`));
      }
      else if (decimalValue.length > 0 && allowDecimal ) {
        if((decimalValue[1].length > 0 && decimalValue[1].length < 2) && ["0", "5"].includes(decimalValue[1])){
            dispatch(SET_PROJECT_OPTION(minBlockCountApiField, Number(value)));
          }else{
            dispatch(SET_PROJECT_OPTION(minBlockCountApiField, Number(parseInt(value, 10).toFixed(0))));
          }
      } else {
        dispatch(SET_PROJECT_OPTION(minBlockCountApiField, Number(parseInt(value, 10).toFixed(0))));
      }

    }

    function interiorBlockCountFieldValidations(value, checkingValue){
      const min = 0
      const allowDecimal = isHalfBlockAllowed(is_half_block_allowed) ? true : false;
      const allowInteriorBayDecimalValue = isHalfBlockAllowed(is_half_block_allowed) ? true : false
      const interiorBayDecimalValue = value.toString().split('.')
      const max = interiorBayCapacity(productId, isHalfBlockAllowed(is_half_block_allowed));
      if(value <= checkingValue){
        dispatch(SET_FIELD_INVALID(interiorBayCapacityApiField, `Interior bay capacity must greater than min block count`));
      }
      else if (value < min || value > max) {
        dispatch(SET_FIELD_INVALID(interiorBayCapacityApiField, `Interior bay capacity must must lie between ${min+(allowDecimal ? 0.5 : 1)} and ${max}`));
      }
      else if (interiorBayDecimalValue.length > 0 && allowInteriorBayDecimalValue ) {
        if((interiorBayDecimalValue[1].length > 0 && interiorBayDecimalValue[1].length < 2) && ["0", "5"].includes(interiorBayDecimalValue[1])){
            dispatch(SET_PROJECT_OPTION(interiorBayCapacityApiField, Number(value)));
          }else{
            dispatch(SET_PROJECT_OPTION(interiorBayCapacityApiField, Number(parseInt(value, 10).toFixed(0))));
          }
      } else {
        dispatch(SET_PROJECT_OPTION(interiorBayCapacityApiField, Number(parseInt(value, 10).toFixed(0))));
      }

    }


    const isOk = checkAdditionalUserInputs({ ...currentEnvConfig, [field]: value }, false, productId);
    if (!isOk && additionalUserInputsPage(productId).includes(field)) {
      dispatch(SET_FIELD_INVALID(field, "Please enter a valid value or reset to default"));
    }

  }

  if (isSMTilt(productId)) {
    if (field === smClampsChoicesApiField) {
      updateProjectOptionsOnModuleDimsChange();
    }
  }

  // we need both previous and current values .
  // It's because we check if the field value has changed
  // but also we check if other required fields are already set.
  // For some products user has to choose them, for some they are set automatically.
  // That's why we check if we should recalculate after the other fields has been set.

  const buildingHeightHasChanged = (
    isBuildingHeightField: boolean,
    newFieldValue: number | string,
  ) =>
    (isBuildingHeightField && newFieldValue !== undefined);

  const buildingTypeHasChanged = (
    isBuildingTypeField: boolean,
    newFieldValue: number | string,
  ) =>
    (isBuildingTypeField && Number(newFieldValue) > -1);
  const shortestBuildingLengthHasChanged = (
    isShortestBuildingLengthField: boolean,
    newFieldValue: number | string,
  ) =>
    (isShortestBuildingLengthField && Number(newFieldValue) > -1);

  const longestBuildingLengthHasChanged = (
    isLongestBuildingLengthField: boolean,
    newFieldValue: number | string,
  ) => (
    isLongestBuildingLengthField && !!newFieldValue);

  function shouldRecalculateZonesNon716(
    field: string,
    newFieldValue: number | string,
    previousValues: projectEnvConfig,
    currentValues: projectEnvConfig,
    productId: number,
  ) {
    const isBuildingHeightField = field === buildingHeight.apiField;
    const isBuildingTypeField = field === residentalBuildingTypes.apiField;
    const isShortestBuildingLengthField = field === shortestBuildingLengthApiField;
    const isLongestBuildingLengthField = field === longestBuildingLengthApiField;
    if (!areRequiredFieldsSet({
      buildingHeightValue: currentValues.building_height,
      field,
      longestBuildingLengthValue: currentValues.building_length,
      newFieldValue,
      productId,
      shortestBuildingLengthValue: currentValues.shortest_building_length,
    })) {
      return false;
    }
    return (
      buildingHeightHasChanged(isBuildingHeightField, newFieldValue) ||
      buildingTypeHasChanged(isBuildingTypeField, newFieldValue) ||
      shortestBuildingLengthHasChanged(isShortestBuildingLengthField, newFieldValue) ||
      longestBuildingLengthHasChanged(isLongestBuildingLengthField, newFieldValue)
    );
  }
  const shouldRecalculatePanelZonesNon716 = shouldRecalculateZonesNon716(
    field,
    value,
    previousEnvConfig,
    currentEnvConfig,
    productId);




  const shouldRecalculateAsce = shouldRecalculateAsce716(
    field,
    value,
    previousEnvConfig,
    currentEnvConfig,
    productId,
  );
  let shouldRecalculateNonAsce = shouldRecalculateNonAsce716or722(field, value);
  const isBuildingCodeHasChangedToAsce716 = buildingCodeHasChangedToAsce716or722(field === buildingCode.apiField, Number(value), previousEnvConfig.building_code, currentEnvConfig.building_height);

  const changeRoofPitch = () => {
    if (isRM5(productId) || isRM10orRM10Evo(productId)) {
      const roofs = getProjectRoofs();
      if (roofs) {
        Object.keys(roofs).forEach(roofKey => {
          const roofId = Number(roofKey);
          const roof: drawingManagerRoof = roofs[roofId];
          if (roof.roofPitch > 5) {
            dispatch(SET_ROOF_ROOF_PITCH(roofId, '0'));
          }
        });
      }
    }
  };


  const {
    wind_exposure: prev_wind_exposure, building_code: prev_building_code, risk_category: prev_risk_category,
    roof_type: prev_roof_type,
    material_thickness: prev_material_thickness, wind_speed: prev_wind_speed,
    limit_down_point_loads: prev_limit_down_point_loads,
  } = previousEnvConfig;
  const {
    wind_exposure: current_wind_exposure, building_code: current_building_code, risk_category: current_risk_category,
    dead_load_factor_modification: current_dead_load_factor_modification, soil_class: current_soil_class,
    topographical_factor_kzt: current_topographical_factor_kzt,
    wind_speed: current_wind_speed,
    snow_load: current_snow_load,
    tilt,
    roof_type: current_roof_type,
    material_thickness: current_material_thickness,
    block_weight: current_block_weight,
    is_half_block_allowed: current_is_half_block_allowed,
    half_block_weight: current_half_block_weight,
    building_length: current_building_length,
    shortest_building_length: current_shortest_building_length,
    building_height: current_building_height,
    preferred_span: current_preferred_span,
    rafter_spacing_inches: current_rafter_spacing_inches,
    attachment_type: current_attachment_type,
    roof_substrate: current_roof_substrate,
    setback_distance: current_setback_distance,
    rain_load: current_rain_load,
    manufacturer,
    colour,
    choice_of_fastend,
    sub_category,
  } = currentEnvConfig;
  let attachment_values;

  const ss_thickness_values = configStandingSeam.data.map(d => d.value);

  const rp_thickness_values = configRPanel.data.map(d => d.value);

  const cm_thickness_values = configCorrugated.data.map(d => d.value);


  if (isMetalX(productId)) {

    if (field === topographicalFactorKztApiField && value !== previousEnvConfig.topographical_factor_kzt) {
      if (value < topographicalFactorKzt.min || value > topographicalFactorKzt.max) {
        dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Topographical Factor must lie in between ${topographicalFactorKzt.min} and ${topographicalFactorKzt.max}`));
      }
      if (isASCE710(current_building_code)) {
        if (current_topographical_factor_kzt * Number(current_wind_speed) > 190) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
        }
      }
    }
    if ((field === metalXRoofTypeApiField && value !== prev_roof_type) || (field === mxMaterialThicknessApiField && value !== prev_material_thickness)) {
      const standingSeamSelected = current_roof_type === ROOF_TYPES.STANDING_SEAM;
      const rPanelSelected = current_roof_type === ROOF_TYPES.R_PANEL;
      const corrugatedSelected = current_roof_type === ROOF_TYPES.CORRUGATED_METAL;
      const roofTypeOptions = [standingSeamSelected, rPanelSelected, corrugatedSelected];
      attachment_values = getAttachmentTypeOptions(roofTypeOptions, current_material_thickness).map(i => i.value);
      if (attachment_values.length === 0) {
        if (current_roof_type === ROOF_TYPES.STANDING_SEAM && !ss_thickness_values.includes(current_material_thickness)) {
          dispatch(SET_PROJECT_OPTION(mxMaterialThicknessApiField, MATERIAL_THICKNESS.GA_22));
          dispatch(SET_PROJECT_OPTION(metalXAttachmentTypeField, ATTACHMENT_TYPES.STAND_2SS));
        } else if (current_roof_type === ROOF_TYPES.R_PANEL && !rp_thickness_values.includes(current_material_thickness)) {
          dispatch(SET_PROJECT_OPTION(mxMaterialThicknessApiField, MATERIAL_THICKNESS.GA_22));
          dispatch(SET_PROJECT_OPTION(metalXAttachmentTypeField, ATTACHMENT_TYPES.PM_ADJUST_SLOTTED));
        } else if (current_roof_type === ROOF_TYPES.CORRUGATED_METAL && !cm_thickness_values.includes(current_material_thickness)) {
          dispatch(SET_PROJECT_OPTION(mxMaterialThicknessApiField, MATERIAL_THICKNESS.GA_22));
          dispatch(SET_PROJECT_OPTION(metalXAttachmentTypeField, ATTACHMENT_TYPES.CORRUBRACKET));
        }
      } else {
        dispatch(SET_PROJECT_OPTION(metalXAttachmentTypeField, attachment_values[0]));
      }
    }
    if (field === windSpeedApiField) {
      if (isASCE710(current_building_code)) {
        if (current_topographical_factor_kzt * Number(current_wind_speed) > 190) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
        }
      }
    }
    if (field === buildingCodeApiField && value !== previousEnvConfig.building_code) {
      if (isASCE716(current_building_code)) {
        dispatch(CLEAR_INVALID_FIELD(topographicalFactorKztApiField));
      }
      if (isASCE710(current_building_code)) {
        if (current_topographical_factor_kzt * Number(current_wind_speed) > 190) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
        }
      }
    }
  }

  if (isCanadianChangesProduct(productId)) {
    if (field === rainLoadApiField) {
      if (current_rain_load < 0.1 || current_rain_load > 1) {
        dispatch(SET_FIELD_INVALID(rainLoadApiField, 'Rain Load (Sr) must lie between 0.1 and 1'));
      }
    }
  }

  if (isRMFamily(productId)) {

    if((UanchorSubCategoryType.SILICONE_BASED == uAnchorRoof(current_roof_type, sub_category)) && current_attachment_type == AttachmentType.UNIRAC_FLASHLOC_RM && uAnchorImprovements(projectVersion)){
      dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.U_ANCHOR_U2400));
    }

    if (field === buildingHeightApiField && value !== previousEnvConfig[buildingHeightApiField]) {
      const { drawingManager: { roofs } } = state();
      if((!hasNoRoofs()) && anyRoofHasPanels(roofs) && canShowSkewZone(productId, mapType, projectVersion)) {
        reCalculateSkewZoneAndPanelsForAllRoofs();
      }
      if (isASCE705(current_building_code)) {
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
      } else if (!isCanadianZipcode) {
        const deadLoadFactor = (current_wind_exposure === 'D' || current_risk_category > 3) || current_wind_speed > 140 || current_building_height > 100 ? 0.6 : null;
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor||current_dead_load_factor_modification));
      }
    }

    if (field === windExposureApiField &&
      current_wind_exposure !== prev_wind_exposure) {
      if (isASCE705(current_building_code)) {
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
      } else if (!isCanadianZipcode) {
        const deadLoadFactor = current_wind_exposure === 'D' || current_risk_category > 3 || current_wind_speed > 140 || current_building_height > 100 ? 0.6 : null;
        if (current_dead_load_factor_modification !== deadLoadFactor) dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor||current_dead_load_factor_modification));
      }
    }


    if (field === buildingCodeApiField && current_building_code !== prev_building_code) {
      if (isASCE705(current_building_code)) {
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
      } else if (!isCanadianZipcode) {
        const deadLoadFactor = (current_wind_exposure === 'D' || current_risk_category > 3) || current_wind_speed > 140 || current_building_height > 100 ? 0.6 : null;
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor||current_dead_load_factor_modification));
      }
    }

    if (field === windSpeedApiField && current_wind_speed !== prev_wind_speed) {
      if (isASCE705(current_building_code)) {
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
      } else if (!isCanadianZipcode) {
        const deadLoadFactor = current_wind_exposure === 'D' || current_risk_category > 3 || current_wind_speed > 140 || current_building_height > 100 ? 0.6 : null;
        if (current_dead_load_factor_modification !== deadLoadFactor) {
          dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor||current_dead_load_factor_modification));
        }
      }
    }

    if (field === riskCategory.apiField && current_risk_category !== prev_risk_category) {
      if (isASCE705(current_building_code)) {
        dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
      } else if (!isCanadianZipcode) {
        const deadLoadFactor = current_wind_exposure === 'D' || current_risk_category > 3 || current_wind_speed > 140 || current_building_height > 100 ? 0.6 : null;
        if (current_dead_load_factor_modification !== deadLoadFactor) dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor||current_dead_load_factor_modification));
      }
    }

    if (field === buildingHeightApiField && (value !== previousEnvConfig.building_height || value === 0)) {
      const { lowerLimit, upperLimit } = getBuildingHeightLimits();
      if (isRM10orRM10Evo(productId) || isRM5(productId) || isRMGridFlex(productId) || isRMDT(productId) || isEcoFoot2Plus(productId)) {
        if (value < lowerLimit || value > upperLimit) {
          dispatch(SET_FIELD_INVALID(buildingHeightApiField, `Building height must lie between ${lowerLimit} and ${upperLimit}.`));
        }
        if(isASCE716or722(previousEnvConfig.building_code) && buildingHeightCheck(value, inputUnit)){
          dispatch(SET_PROJECT_OPTION(buildingStoreyApiField, previousEnvConfig.building_height_greater_than_6_storey));
        }
      } else if (value < lowerLimit || value > upperLimit) {
        dispatch(SET_FIELD_INVALID(buildingHeightApiField, `Building height must lie between ${lowerLimit} and ${upperLimit}.`));
      }
    }

    if (isRM10Evolution(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      if (field === rmIFIParapetHeightApiField && value !== previousEnvConfig.parapet_height_input) {
        if (isMetricUnit(inputUnit)) {
          if (value < rmIFIParapetHeightMetric.min || value > rmIFIParapetHeightMetric.max) {
            dispatch(SET_FIELD_INVALID(
              rmIFIParapetHeightApiField,
              `Parapet Height must lie between ${rmIFIParapetHeightMetric.min} and ${rmIFIParapetHeightMetric.max} meters`));
          }
        }
        else {
          if (value < rmIFIParapetHeight.min || value > rmIFIParapetHeight.max) {
            dispatch(SET_FIELD_INVALID(
              rmIFIParapetHeight.apiField,
              `Parapet Height must lie between ${rmIFIParapetHeight.min} and ${rmIFIParapetHeight.max} inches`));
          }
        }

      }
    }

    if (isRM10Evolution(productId) && field === "enable_cpp") {
      const deadLoadFactor = value ? 0.6 : 1;
      if (current_dead_load_factor_modification !== deadLoadFactor) dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, deadLoadFactor));
    }

    if (isRMIFIProduct(productId) || isRM10(productId) || isRM10Evolution(productId) || isRMGridFlex(productId) || isRM5(productId) || isRMDT(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      const { projectConfiguration: { projectVersion } } = state();
      if (field === deadLoadFactorApiField && !isCanadianZipcode) {
        if (isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)){
          if ((current_wind_exposure === 'D' || current_risk_category > 2 || current_wind_speed > 140 || current_building_height > 100) && (value < 0.001 || value > 0.6)) {
            dispatch(SET_FIELD_INVALID(deadLoadFactorApiField, 'Please enter the dead load factor ranging from  0.001 to 0.6'));
          } else if (value < 0.001 || value > 0.75) {
            dispatch(SET_FIELD_INVALID(deadLoadFactorApiField, 'Please enter the dead load factor ranging from  0.001 to 0.75'));
          }
        }
        else{
          if ((isASCE705(current_building_code) || current_wind_exposure === 'D' || current_risk_category > 3 || current_wind_speed > 140 || current_building_height > 100) && (value < 0.001 || value > 0.6) && applyDeadloadFactorLimitChanges(projectVersion)) {
            if(value > 0.6){
              dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6));
            }
            else if(value < 0.001){
              dispatch(SET_FIELD_INVALID(deadLoadFactorApiField, 'Please enter the dead load factor ranging from  0.001 to 0.6'));
            }
          } else {
            if(value > 1){
              dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 1));
            }
            else if(value < 0.001){
              dispatch(SET_FIELD_INVALID(deadLoadFactorApiField, 'Please enter the dead load factor ranging from  0.001 to 1'));
            }
          }
        }
      }

      if (field === topographicalFactorKztApiField && value !== previousEnvConfig.topographical_factor_kzt) {
        if (value < topographicalFactorKzt.min) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Topographical Factor must be greater than or equal to ${topographicalFactorKzt.min}`));
        }
        if (value > topographicalFactorKzt.max) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Topographical Factor must be less than or equal to ${topographicalFactorKzt.max}`));
        }
      }
      if (field === buildingCodeApiField && current_building_code !== prev_building_code) {
        if (isASCE710(current_building_code)) {
          if (current_soil_class === SOIL_CLASS.D_DEFAULT) {
            dispatch(SET_PROJECT_OPTION(soilClassApiField, SOIL_CLASS.D));
          }
        }
      }
      if (field === rmIFIParapetHeight.apiField && value !== previousEnvConfig.parapet_height_input) {
        if (value < rmIFIParapetHeight.min || value > rmIFIParapetHeight.max) {
          dispatch(SET_FIELD_INVALID(
            rmIFIParapetHeightApiField,
            `Parapet Height must lie between ${rmIFIParapetHeight.min} and ${rmIFIParapetHeight.max} inches`));
        }
      }
      showTornadoSpeedWarning();
    }
    if (isRMIFIProduct(productId) || isRM5(productId) || isRM10(productId) || isRM10Evolution(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      const units = isMetricUnit(inputUnit) ? 'kg' : 'lbs';

      if (field===rm_roof_type && value !== previousEnvConfig.roof_type && !u_anchor_roofs_list.includes(parseInt(value)) && uAnchorAttachments(projectVersion) &&
            current_attachment_type===AttachmentType.U_ANCHOR_U2400 && (isRM10Evolution(productId) || isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) || isRMGridFlex(productId))){
            dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.UNIRAC_FLASHLOC_RM))
            dispatch(SET_PROJECT_OPTION(uAnchorPartNumberApiField, null))
        }
      const { projectConfiguration: { projectEnvConfig : { attachment_type } } } = state();

      if (field === allowMechanicalAttachmentsApiField && value !== previousEnvConfig.allow_mechanical_attachments) {
        if (value === 1) {
          dispatch(SET_PROJECT_OPTION(attachmentOptimizationCriteriaApiField, AttachmentOptimization.MAXIMIZE_BALLAST));
          if((isRM10Evolution(productId) || isRM5(productId) || isRMGridFlex(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) ) && uAnchorImprovements(projectVersion) && u_anchor_roofs_list.includes(parseInt(current_roof_type))){
              dispatch(SET_PROJECT_OPTION(attachmentTypeApiField,AttachmentType.U_ANCHOR_U2400))
              changeRoofPitch();
              dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
              dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
            }
          else{
            dispatch(SET_PROJECT_OPTION(attachmentTypeApiField,AttachmentType.UNIRAC_FLASHLOC_RM));
            changeRoofPitch();
            dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForFlashloc(productId, inputUnit).default));
            dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForFlashloc(productId, inputUnit).default));
          }
        } else {
          dispatch(SET_PROJECT_OPTION(attachmentOptimizationCriteriaApiField, null));
          dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, null));
          dispatch(SET_PROJECT_OPTION(roofPsfLimitApiField, null));
          dispatch(SET_PROJECT_OPTION(totalWeightOnRoofLimitApiField, null));
          dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField, 0));
          (isRMGridFlex(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) ) && dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField,getYesOrNo()[1].value));
        }
      } else if (field === attachmentOptimizationCriteriaApiField && value !== previousEnvConfig.attachment_optimization_criteria) {
        if (value !== AttachmentOptimization.PSF_LIMIT) {
          dispatch(SET_PROJECT_OPTION(roofPsfLimitApiField, null));
        }
        if (value !== AttachmentOptimization.TOTAL_WEIGHT_ON_THE_ROOF) {
          dispatch(SET_PROJECT_OPTION(totalWeightOnRoofLimitApiField, null));
        }
      } else if (field === roofPsfLimitApiField && value !== previousEnvConfig.roof_psf_limit) {
        if (value < roofPsfLimit.min || value > roofPsfLimit.max) {
          dispatch(SET_FIELD_INVALID(
            roofPsfLimitApiField,
            `Roof PSF limit must lie between ${roofPsfLimit.min.toFixed(2)} and ${roofPsfLimit.max.toFixed(2)} PSF`));
        }
      } else if (field === totalWeightOnRoofLimitApiField && value !== previousEnvConfig.total_weight_on_roof_limit) {
        if (value < totalWeightonRoofLimit.min || value > totalWeightonRoofLimit.max) {
          dispatch(SET_FIELD_INVALID(
            totalWeightOnRoofLimitApiField,
            `Total Weight on Roof must lie between ${totalWeightonRoofLimit.min} and ${totalWeightonRoofLimit.max} lbs`));
        }
      } else if (((field === attachmentTypeApiField ) && (value !== previousEnvConfig.attachment_type)) || ((field === roofTypeApiField) && (value !== previousEnvConfig.roof_type)) || ((field === subCategoryField) && (value !== previousEnvConfig.sub_category))){
        if (field === attachmentTypeApiField ? value === AttachmentType.U_ANCHOR_U2400 : attachment_type === AttachmentType.U_ANCHOR_U2400) {
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
        } else if (field === attachmentTypeApiField ? value === AttachmentType.UNIRAC_FLASHLOC_RM : attachment_type === AttachmentType.UNIRAC_FLASHLOC_RM) {
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForFlashloc(productId, inputUnit).default));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForFlashloc(productId, inputUnit).default));
          changeRoofPitch();
          dispatch(SET_FIELD_WARNING(field, 'Note: Max roof slope for Flasloc RM is 5 degrees'));
        } else if (field === attachmentTypeApiField ? value === AttachmentType.CUSTOM : attachment_type === AttachmentType.CUSTOM) {
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForCustom(productId, inputUnit).default));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForCustom(productId, inputUnit).default));
        } else if (field === attachmentTypeApiField ? value === AttachmentType.OMG : attachment_type === AttachmentType.OMG) {
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForOMG(productId, inputUnit).default));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForOMG(productId, inputUnit).default));
        } else if(isMetricUnit(inputUnit)){
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowabledefaultValueKg));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowabledefaultValueKg));
        } else {
          dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowabledefaultValue));
          dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowabledefaultValue));
        }
        if (value !== AttachmentType.UNIRAC_FLASHLOC_RM) {
          dispatch(CLEAR_WARNING(field));
        }
      } else if (field === anchorTypeApiField){
        dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
        dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).default));
      } else if (field === upliftAllowableApiField) {
        if (currentEnvConfig.attachment_type === AttachmentType.CUSTOM && (value < upliftAllowableForCustom(productId, inputUnit).min || value > upliftAllowableForCustom(productId, inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            upliftAllowableApiField,
            `Uplift Allowable must lie between ${upliftAllowableForCustom(productId, inputUnit).min} and ${upliftAllowableForCustom(productId, inputUnit).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.UNIRAC_FLASHLOC_RM && (value < upliftAllowableForFlashloc(productId, inputUnit).min || value > upliftAllowableForFlashloc(productId, inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            upliftAllowableApiField,
            `Uplift Allowable must lie between ${upliftAllowableForFlashloc(productId, inputUnit).min} and ${upliftAllowableForFlashloc(productId, inputUnit).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.U_ANCHOR_U2400 && (value < upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).min || value > upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).max)) {
          dispatch(SET_FIELD_INVALID(
            upliftAllowableApiField,
            `Uplift Allowable must lie between ${upliftAllowableForUAnchor(productId, 1, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).min} and ${upliftAllowableForUAnchor(productId, 1, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.OMG && (value < upliftAllowableForOMG(productId, inputUnit).min || value > upliftAllowableForOMG(inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            upliftAllowableApiField,
            `Uplift Allowable must lie between ${upliftAllowableForOMG(productId, inputUnit).min} and ${upliftAllowableForOMG(productId, inputUnit).max} ${units}`));
        }
      } else if (field === shearAllowableApiField) {
        if (currentEnvConfig.attachment_type === AttachmentType.CUSTOM && (value < shearAllowableForCustom(productId, inputUnit).min || value > shearAllowableForCustom(productId, inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            shearAllowableApiField,
            `Shear Allowable must lie between ${shearAllowableForCustom(productId, inputUnit).min} and ${shearAllowableForCustom(productId, inputUnit).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.UNIRAC_FLASHLOC_RM && (value < shearAllowableForFlashloc(productId, inputUnit).min || value > shearAllowableForFlashloc(productId, inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            shearAllowableApiField,
            `Shear Allowable must lie between ${shearAllowableForFlashloc(productId, inputUnit).min} and ${shearAllowableForFlashloc(productId, inputUnit).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.U_ANCHOR_U2400 && (value < shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).min || value > shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).max)) {
          dispatch(SET_FIELD_INVALID(
            shearAllowableApiField,
            `Shear Allowable must lie between ${shearAllowableForUAnchor(productId, 1, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).min} and ${shearAllowableForUAnchor(productId, 1, projectVersion, inputUnit, currentEnvConfig?.choice_of_fastend).max} ${units}`));
        } else if (currentEnvConfig.attachment_type === AttachmentType.OMG && (value < shearAllowableForOMG(productId, inputUnit).min || value > shearAllowableForOMG(productId, inputUnit).max)) {
          dispatch(SET_FIELD_INVALID(
            shearAllowableApiField,
            `Shear Allowable must lie between ${shearAllowableForOMG(productId, inputUnit).min} and ${shearAllowableForOMG(productId, inputUnit).max} ${units}`));
        }
      } else if (field === ballastBlockHalfWeightApiField && value !== previousEnvConfig.half_block_weight) {
        const ballastBlockHalfWeight = ballastBlockHalfWeightField(inputUnit);
        if (value < ballastBlockHalfWeight.min || value > ballastBlockHalfWeight.max) {
          dispatch(SET_FIELD_INVALID(
            ballastBlockHalfWeightApiField,
            `Half block weight must lie between ${ballastBlockHalfWeight.min} and ${ballastBlockHalfWeight.max} ${units}`));
        }
        else if (value >= current_block_weight) {
          dispatch(SET_FIELD_INVALID(
            ballastBlockHalfWeightApiField,
            `Half block weight must be less than full block weight (${current_block_weight} ${units})`));
        }
      }
      else if (field === choiceOfFastendField && value !== previousEnvConfig?.choice_of_fastend) {
        dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, upliftAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, value).default));
        dispatch(SET_PROJECT_OPTION(shearAllowableApiField, shearAllowableForUAnchor(productId, currentEnvConfig.anchor_type, projectVersion, inputUnit, value).default));
      }
    }
    if (isRM10Evolution(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      if (field == parapetHeightInputApiField && value == null) {
        dispatch(SET_PROJECT_OPTION(parapetHeightInputApiField, 0));
      }
    }


    if( field===rm_roof_type && value !== previousEnvConfig.roof_type ) {
        dispatch(SET_PROJECT_OPTION(subCategoryField, null))
        dispatch(SET_PROJECT_OPTION(manufacturerField, null))
        dispatch(SET_PROJECT_OPTION(colourField, null))
        dispatch(SET_PROJECT_OPTION(choiceOfFastendField, null))
        if (isRmGridflex10D(productId) || isRMGridFlex(productId) || isRmGridflex5Rwdi(productId)){
          dispatch(SET_PROJECT_OPTION(frictionFactorApiField ,getFrictionFactor(value, productId)))
        }
    }
    if( field===subCategoryField && value !== previousEnvConfig.sub_category && !uAnchorImprovements(projectVersion)) {
      dispatch(SET_PROJECT_OPTION(manufacturerField, null));
      dispatch(SET_PROJECT_OPTION(colourField, null));
      dispatch(SET_PROJECT_OPTION(choiceOfFastendField, null));
    }
    if( field===manufacturerField && value !== previousEnvConfig.manufacturer && !uAnchorImprovements(projectVersion) ) {
      dispatch(SET_PROJECT_OPTION(colourField, null));
      dispatch(SET_PROJECT_OPTION(choiceOfFastendField, null));
    }
    if( field===colourField && value !== previousEnvConfig.colour && !uAnchorImprovements(projectVersion)) {
      dispatch(SET_PROJECT_OPTION(choiceOfFastendField, null));
    }

    if((manufacturer && uAnchorImprovements(projectVersion) ? true : choice_of_fastend) && [21, 22].includes(current_roof_type)){
      dispatch(SET_PROJECT_OPTION(colourField, 'N'));
    }
    if([attachmentTypeApiField, manufacturerField, choiceOfFastendField, colourField, subCategoryField].includes(field) && (uAnchorAttachments(projectVersion) && uAnchorImprovements(projectVersion) ? true : (current_attachment_type===AttachmentType.U_ANCHOR_U2400 && choice_of_fastend)) && current_roof_type && manufacturer) {
      const u_anchor_starting_char = "UA";
      const u_anchor_roof = uAnchorRoof(current_roof_type, sub_category);
      const uAnchorPartNumber = u_anchor_starting_char + (choice_of_fastend ? choice_of_fastend : 0)+ manufacturer + u_anchor_roof + (colour ? colour : 'N');
      dispatch(SET_PROJECT_OPTION(uAnchorPartNumberApiField, uAnchorPartNumber));
    }
  }

  if (isEcoFoot2Plus(productId)) {
    if (field === windSpeedApiField && !isCanadianZipcode) {
      if (value < 85 || value > 180) {
        dispatch(SET_FIELD_INVALID(windSpeedApiField, `Wind speed must lie between 85 and 180.`));
      }
    }
  }

  if (!applyAsce722AccessForRM10Evo(productId, projectVersion) && !applyAsce722AccessForEcoFoot2Plus(productId, projectVersion) && !permissions.includes(ACCESS_FOR_7_22_PERMISSION) && disabled722BuildingCodeProducts(productId) && field === buildingCodeApiField &&  previousEnvConfig.building_code === asce_722.value && value !== asce_722.value){
    dispatch(HIDE_CONFIRM_CLEAR_ARRAYS_MODAL());
  }

  if(!applyAsce722AccessForRM10Evo(productId, projectVersion) && !applyAsce722AccessForEcoFoot2Plus(productId, projectVersion) && !permissions.includes(ACCESS_FOR_7_22_PERMISSION) && disabled722BuildingCodeProducts(productId) && field === buildingCodeApiField && current_building_code === asce_722.value){
      dispatch(SET_FIELD_INVALID(buildingCodeApiField, `Incompatible with ASCE 7-22. Please choose an appropriate building code.`));
  }

  if(isEcoFoot2Plus(productId) || isRM10orRM10Evo(productId) || isRM5(productId) || isRMIFIProduct(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
    const { lowerLimit, upperLimit } =  getSetbackLimits();

    if (field === buildingHeightApiField || field === setbackDistanceApiField) {
      if (lowerLimit > current_setback_distance || current_setback_distance > upperLimit) {
        dispatch(SET_FIELD_INVALID(setbackDistanceApiField, `Setback distance must lie between ${lowerLimit} and ${upperLimit}`));
      } else {
        if (isMetricUnit(inputUnit) ? current_setback_distance >= metersToCms(current_building_height) / 2 : current_setback_distance >= current_building_height / 2) {
          dispatch(SET_FIELD_INVALID(setbackDistanceApiField, `Setback distance must be less than 1/2*building height (${isMetricUnit(inputUnit) ? `${round(metersToCms(current_building_height) / 2, 1)} cm` : `${current_building_height / 2} ft`})`));
        } else {
          dispatch(CLEAR_INVALID_FIELD(setbackDistanceApiField));
        }
      }
    }
    if (field === setbackDistanceApiField && currentEnvConfig.building_code === previousEnvConfig.building_code) {
      shouldRecalculateNonAsce = true;
    }
  }


  if (isEcoFoot2Plus(productId) || isRMFamily(productId)) {
    const maxDownPointLoadToBeAllowed = maxDownPointLoadToBeAllowedField(inputUnit);
    if (field === limitDownPointLoadsApiField && value != prev_limit_down_point_loads) {
      dispatch(SET_PROJECT_OPTION(maxDownPointLoadToBeAllowedApiField, undefined));
    }
    else if (field === maxDownPointLoadToBeAllowedApiField && value !== previousEnvConfig.max_down_point_load_to_be_allowed) {
      if (value < maxDownPointLoadToBeAllowed.min || value > maxDownPointLoadToBeAllowed.max) {
        dispatch(SET_FIELD_INVALID(
          maxDownPointLoadToBeAllowedApiField,
          `Max Point load must lie between ${maxDownPointLoadToBeAllowed.min} and ${maxDownPointLoadToBeAllowed.max}`));
      }
    }
  }


  const useNewZoneClassification = needNewZoneClassification(projectVersion);
  if (!isASCE716or722Selected() && shouldRecalculatePanelZonesNon716 && !isRMIFIProduct(productId) && useNewZoneClassification) {
    updateNon716Panels(productId);
  } else if (shouldRecalculateAsce && !isRMIFIProduct(productId)) {
    switchProjectToASCE716(productId, isBuildingCodeHasChangedToAsce716);
  } else if (shouldRecalculateNonAsce) {
    switchProjectToNonASCE716(productId);
  }

  if (field === buildingCode.apiField) {
    setProperRoofPitchForResidentialsASCE716(value, currentEnvConfig.building_type);
  }

  if (field === clampsChoice.apiField) {
    if (value === 0) {
      dispatch(SET_ROW_SPACING(inchesToMeters(1)));
    }

    if (value === 1) {
      dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
    }
  }

  if (field === buildingCode.apiField || field === riskCategoryApiField) {
    const currentBuildingCode = field === buildingCode.apiField ? value : currentEnvConfig.building_code;
    const risk_category = field === riskCategoryApiField ? value : currentEnvConfig.risk_category;

    dispatch(CLEAR_ENV_FACTORS_FOR());

    if (zipcode && zipcode.length) {
      updateEnviromentalFactors(zipcode, currentBuildingCode, productId, risk_category);
    }
    if ((isASCE716or722(currentBuildingCode) && (isGFT(productId))) || isRMAndEcofootFamily(productId) || isRMIFIProduct(productId)) {
      enableObstructionsZoneView();
    } else {
      disableObstructionZoneView();
      disableWindZoneView();
    }

    if ((prev_building_code != current_building_code && isASCE722(current_building_code))){
      let envFactorsApiFields = [snowLoadApiField, seismicSsApiField, seismicS1ApiField, seismicSds.apiField, seismicSd1.apiField, deadLoadFactorApiField]
      envFactorsApiFields = isCanadianChangesProduct(productId) && isCanadianZipcode ? envFactorsApiFields: [...envFactorsApiFields, riskCategoryApiField, windSpeedApiField ];
      envFactorsApiFields.forEach((field)=>(dispatch(SET_PROJECT_OPTION(field, ''))))
      dispatch(SET_PROJECT_OPTION(elevation.apiField, ''))
      dispatch(SET_PROJECT_OPTION(tornadoSpeed.apiField, 0))
      dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6))
      dispatch(SET_PROJECT_OPTION(riskCategoryApiField, RiskCategory.II))
    }
  }
  
  if (field === snowLoadApiField) {
    onSnowLoadChanged(value, productId, currentEnvConfig);
  }

  if (field === staggerAttachments.apiField) {
    onStaggerAttachmentsChanged(value, productId, currentEnvConfig);
  }

  if (isULA(productId)) {

    const { rail_type, clamp_type } = currentEnvConfig;
    const { rail_type: prev_rail_type } = previousEnvConfig;

    if (field === ulaClampsType().apiField) {
      if ((value === "11") || (value === "13")) {
        dispatch(SET_ROW_SPACING(inchesToMeters(1)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(1)));
      } else if ((value === "01") || (value === "02") || (value === "03")) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.25)));
      } else if (value === '04') {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
      }
    }

    if(field === ulaClampsType().apiField && clamp_type === PRO_SERIES){
      dispatch(SET_FIELD_INVALID(ulaClampsType().apiField , `Incompatible with PRO SERIES clamp option. Please choose an appropriate clamp option.`));
    }

    if (field === clampLocation.apiField) {
      if (clamp_type === PRO_SERIES && (value === ULAClampLocationType.TOP_CLAMPS || value === ULAClampLocationType.BOTH_TOP_AND_BOTTOM_CLAMPS)) {
        dispatch(SET_ROW_SPACING(inchesToMeters(1)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(1)));
      } else if ((clamp_type === STANDARD && (value === ULAClampLocationType.TOP_CLAMPS || value === ULAClampLocationType.BOTH_TOP_AND_BOTTOM_CLAMPS)) || value === ULAClampLocationType.BOTTOM_CLAMPS) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.25)));
      }

    }

    if (field === railTypeApiField && value !== prev_rail_type) {
      if (rail_type === ULARailType.SM_HD && value !== prev_rail_type) {
        dispatch(SET_PROJECT_OPTION(clampLocation.apiField, ULAClampLocationType.TOP_CLAMPS));
      }
    }

    if (field === frontEdgeHeightApiField) {
      if (value < 1.5 || value > 5) {
        dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between 1.5 and 5`));
      }
    }

    if (field === foundationTypeULAApiField) {
      const { foundation_type: prev_foundation_type_value } = previousEnvConfig;
      if (value === prev_foundation_type_value) return;
      if (value === foundationTypeULAOptions.aboveGradeBallast.value || value === foundationTypeULAOptions.groundScrew.value) {
        dispatch(SET_PROJECT_OPTION(foundationDiameterULAApiField, null)); // clear out foundation Diameter field if Ballast or groundscrew Foundation is selected
      } else if (value === foundationTypeULAOptions.concrete.value) {
        dispatch(SET_PROJECT_OPTION(foundationDiameterULAApiField, 18)); // set the default foundation Diameter value to 18 if Concrete Foundation is selected
      }
    }

    if (field === foundationTypeULAApiField) {
      const { foundation_screw_length: prev_foundation_screw_length } = previousEnvConfig;
      if (value === prev_foundation_screw_length) return;
      if (value === foundationTypeULAOptions.aboveGradeBallast.value || value === foundationTypeULAOptions.concrete.value) {
        dispatch(SET_PROJECT_OPTION(foundationScrewLengthApiField, null)); // clear out foundation Screw length field if ballast and concrete Foundation is selected
      } else if (value === foundationTypeULAOptions.groundScrew.value) {
        dispatch(SET_PROJECT_OPTION(foundationScrewLengthApiField, 1600)); // set the default foundation Screw length value to 1600 if ground Screw Foundation is selected
        if (applyKrinnerGroundScrewULA(projectVersion)) {
          dispatch(SET_PROJECT_OPTION(groundScrewManufacturerApiField, 1));
        }
      }
    }

    showTornadoSpeedWarning();
  }

  if (isGFT(productId)) {

    if (field === 'clamp_type') {
      if (value === '01') {
        dispatch(SET_ROW_SPACING(inchesToMeters(1)));
      }

      if (value === '11') {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
      }

      if (value === '04') {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
      }
    }

    if (field === tiltApiField) {
      const { tilt: prev_tilt_value } = previousEnvConfig;
      if (prev_tilt_value === value) { // dont update frontEdgeHeight field if same tilt value has been reselected
        return;
      }
      const _default = get(frontEdgeHeight, ['data', value, 'default']);
      if (_default) {
        dispatch(SET_PROJECT_OPTION(frontEdgeHeight.apiField, _default));
      }
    }

    if (field === frostDepthApiField) {
      const two_decimal_validator = (value) => {
        return value.toFixed(2).replace(/\.?0*$/, '');
      };

      const two_decimal_value_input = two_decimal_validator(value);
      dispatch(SET_PROJECT_OPTION(frostDepthApiField, two_decimal_value_input));
    }

    if (field === frontEdgeHeightApiField) {
      const { tilt } = currentEnvConfig;
      const { frost_depth, foundation_type, front_edge_height } = currentEnvConfig;

      if (!frontEdgeHeight.data[tilt]) return;
      const { min, max } = frontEdgeHeight.data[tilt];
      const minFrontedgeHeightForFrostDepthGftForTilt_20 = 2;
      const maxFrontedgeHeightForFrostDepthGftForTilt_20 = 4.5;
      const minFrontedgeHeightForFrostDepthGftForTilt_30 = 2.5;
      const maxFrontedgeHeightForFrostDepthGftForTilt_30 = 3;
      const maxFrontedgeHeightForDrivenFoundation = frontEdgeHeightMaxLimitChange(projectVersion) ? MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN : max;

      if (foundation_type === FoundationType.DRIVEN) {
        if (value < min || value > maxFrontedgeHeightForDrivenFoundation) {
          dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${min} and ${maxFrontedgeHeightForDrivenFoundation} feet for ${tilt}\u00B0 tilt`));
        }
      } else if (frost_depth <= 3.5) {
        if (value < min || value > max) {
          dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${min} and ${max} feet for ${tilt}\u00B0 tilt`));
        }
      } else if (frost_depth > 3.5 && foundation_type === FoundationType.CONCRETE_PILE) {
        if (tilt === 20) {
          if (value < minFrontedgeHeightForFrostDepthGftForTilt_20 || value > maxFrontedgeHeightForFrostDepthGftForTilt_20) {
            dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${minFrontedgeHeightForFrostDepthGftForTilt_20} and ${maxFrontedgeHeightForFrostDepthGftForTilt_20} feet for ${tilt}\u00B0 tilt`));

          } else if (front_edge_height < minFrontedgeHeightForFrostDepthGftForTilt_20 || front_edge_height > maxFrontedgeHeightForFrostDepthGftForTilt_20) {
            dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${minFrontedgeHeightForFrostDepthGftForTilt_20} and ${maxFrontedgeHeightForFrostDepthGftForTilt_20} feet for ${tilt}\u00B0 tilt`));

          }

        } else if (tilt === 30) {
          if (value < minFrontedgeHeightForFrostDepthGftForTilt_30 || value > maxFrontedgeHeightForFrostDepthGftForTilt_30) {
            dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${minFrontedgeHeightForFrostDepthGftForTilt_30} and ${maxFrontedgeHeightForFrostDepthGftForTilt_30} feet for ${tilt}\u00B0 tilt`));

          }
        }
      } else {
        if (value < min || value > max) {
          dispatch(SET_FIELD_INVALID(frontEdgeHeightApiField, `Front edge height must lie between ${min} and ${max} feet for ${tilt}\u00B0 tilt`));
        }
      }
    }

    if (field === iceThicknessApiField) {
      if (value < 0 || value > 2.5) {
        dispatch(SET_FIELD_INVALID(iceThicknessApiField, 'Ice Thickness must lie between 0 and 2.5 in'));
      }
    }

    if (field === windOnIceApiField) {
      if (value < 0 || value > 80) {
        dispatch(SET_FIELD_INVALID(windOnIceApiField, 'Wind on Ice must lie between 0 and 80 mph'));
      }
    }

    if (field === foundationTypeApiField) {
      const { foundation_type: prev_foundation_type_value } = previousEnvConfig;
      if (value === prev_foundation_type_value) return;
      if (value === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationDiameterApiField, null)); // clear out foundation Diameter field if Driven Foundation is selected
        if (currentEnvConfig.front_edge_height > MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN) {
          dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN));
        }
      } else if (value === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationDiameterApiField, 2)); // set the default foundation Diameter value to 2 if CastInPlace Foundation is selected
      }
    }

    if (field === foundationTypeApiField || field === frontEdgeHeightApiField || field === tiltApiField) {
      const { foundation_type, front_edge_height, tilt, foundation_length, frost_depth } = currentEnvConfig;
      const defaultFoundationLength = getDefaultFoundationLength(foundation_type, tilt, front_edge_height, frost_depth)._default;
      if (foundation_type === foundationTypeOptions.driven.value
        && defaultFoundationLength === FOUNDATION_LENGTH.PILE_15
        && foundation_length !== FOUNDATION_LENGTH.PILE_15) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
      } else if (tilt === 20 && frost_depth > 3.5 && front_edge_height === 2 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_12_5));

      } else if (tilt === 20 && frost_depth > 3.5 && front_edge_height > 2 && front_edge_height <= 4.5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 30 && frost_depth > 3.5 && front_edge_height >= 2.5 && front_edge_height <= 3 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 20 && frost_depth > 3.5 && front_edge_height > 4.5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 4.5));
      } else if (tilt === 30 && frost_depth > 3.5 && front_edge_height > 3 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 3));
      } else if (tilt === 20 && front_edge_height > 6.5 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        if (frontEdgeHeightMaxLimitChange(projectVersion)){
          dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN));
        } else {
          dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 6.5));
        }
      } else if (tilt === 30 && front_edge_height > 5 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        if (frontEdgeHeightMaxLimitChange(projectVersion)){
          dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, MAX_FRONT_EDGE_HEIGHT_FOR_DRIVEN));
        } else {
          dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 5));
        }
      } else if (tilt === 20 && frost_depth <= 3.5 && front_edge_height > 6.5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 6.5));
      } else if (tilt === 30 && frost_depth <= 3.5 && front_edge_height > 5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));
        dispatch(SET_PROJECT_OPTION(frontEdgeHeightApiField, 5));
      } else if (tilt === 20 && frost_depth <= 3.5 && front_edge_height === 2 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_10_5));

      } else if (tilt === 20 && frost_depth <= 3.5 && front_edge_height > 2 && front_edge_height <= 4 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_12_5));

      } else if (tilt === 20 && frost_depth <= 3.5 && front_edge_height > 4 && front_edge_height <= 6.5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 30 && frost_depth <= 3.5 && front_edge_height === 2.5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_12_5));

      } else if (tilt === 30 && frost_depth <= 3.5 && front_edge_height > 2.5 && front_edge_height <= 5 && foundation_type === foundationTypeOptions.castInPlace.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 20 && front_edge_height >= 2 && front_edge_height <= 3 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_12_5));

      } else if (tilt === 20 && front_edge_height > 3 && front_edge_height <= 6.5 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 30 && front_edge_height === 2.5 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      } else if (tilt === 30 && front_edge_height > 2.5 && front_edge_height <= 5 && foundation_type === foundationTypeOptions.driven.value) {
        dispatch(SET_PROJECT_OPTION(foundationLengthApiField, FOUNDATION_LENGTH.PILE_15));

      }
    }

    if(field===topChordApiField && ((currentEnvConfig.top_chord === topChordOptions.old_top_chord.value && rail_arrangement_type === railArrangementTypeOptions._8rail.value) || (currentEnvConfig.top_chord === topChordOptions.new_top_chord.value && rail_arrangement_type === railArrangementTypeOptions._5rail.value))) {
      dispatch(SET_PROJECT_OPTION(railArrangementTypeApiField, railArrangementTypeOptions._6rail.value));
    }
    showTornadoSpeedWarning();
  }

  if ((isSolarMount(productId) && tilt === null) || isNxtHorizon(productId) || isSMTiltPR(productId)) {
    const { roof_type: prev_roof_type, tile_replacement_or_solarhooks: prev_tile_replacement_or_solarhooks, attachment_type: prev_attachment_type, s5_roof_manufacturer: prev_s5_roof_manufacturer, s5_roof_panel: prev_s5_roof_panel } = previousEnvConfig;
    const { roof_type, tile_replacement_or_solarhooks, attachment_type, roof_substrate, preferred_span, rail_direction, s5_roof_manufacturer, s5_roof_panel, s5_roof_material, s5_clamp, s5_or_sci } = currentEnvConfig;

    if (field === smRooftypeApiField && value !== prev_roof_type) {
      const s5_not_availavble_roof_type_list = [RoofType.TILE, RoofType.SHINGLE,RoofType.OTHERS]
      // const s5_available_roof_types = [RoofType.STANDING_SEAM, RoofType.R_PANEL,]
      if (roof_type === RoofType.TILE) {
        dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, TileReplacementOrSolarhooks.TILE_REPLACEMENT));
        dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, null));
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, null));
        dispatch(SET_PROJECT_OPTION(preferredSpanApiField, (preferred_span ? preferred_span : 72)))
      }
      if (roof_type === RoofType.SHINGLE || roof_type === RoofType.OTHERS) {
        dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, null));
        dispatch(SET_PROJECT_OPTION(preferredSpanApiField, (preferred_span ? preferred_span : 72)))
      }
      if (roof_type === RoofType.STANDING_SEAM) {
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_22));
        dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.MINI_1SS));
        dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, null));
        if((isSolarMount(productId) && tilt === null) || isNxtHorizon(productId)){
            dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, ''))
            dispatch(SET_PROJECT_OPTION(preferredSpanApiField, ''))
            if(!s5AttachmentsVersion(projectVersion) && !s5_clamp){
              dispatch(SET_PROJECT_OPTION(s5AttachmentpreferenceField, s5AttachmentPreferenceDict.s_5))
            }
        }
        if(isNxtHorizon(productId)){
          dispatch(SET_PROJECT_OPTION(railClampOptionApiField, NXTRailClampOption.RAIL_CLAMP_ONLY));
        }
      }
      if (roof_type === RoofType.R_PANEL) {
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_24));
        dispatch(SET_PROJECT_OPTION(
          attachmentTypeApiField,
          isNxtHorizon(productId) ? AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY : AttachmentType.PM_9000S,
        ));
        dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, null));
        if((isSolarMount(productId) && tilt === null) || isNxtHorizon(productId)){
          dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, ''))
          dispatch(SET_PROJECT_OPTION(preferredSpanApiField, ''))
        }
        if(isNxtHorizon(productId)){
          dispatch(SET_PROJECT_OPTION(railClampOptionApiField, NXTRailClampOption.RAIL_CLAMP_ONLY));
        }
      }
      if (roof_type === RoofType.SHINGLE) {
        const defaultShingleAttachmentType = isNxtHorizon(productId) ? AttachmentType.STRONGHOLD_ATT_BUTYL : (isSolarMount(productId) && tilt === null) ? AttachmentType.SM_BUTYL_DTD : AttachmentType.FLASHKIT_PRO;
        dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, defaultShingleAttachmentType));
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, null));
        dispatch(SET_PROJECT_OPTION(roofSubstrateApiField, [AttachmentType.STRONGHOLD_ATT_BUTYL, AttachmentType.SM_BUTYL_DTD].includes(defaultShingleAttachmentType) ? null : RoofSubstrate.OSB));
      }
      if (roof_type === RoofType.OTHERS) {
        dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, isNxtHorizon(productId) ? AttachmentType.STRONGHOLD_ATT_KIT_COMP : AttachmentType.FLASHKIT_PRO));
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, null));
        dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, null));
      }
      if (((s5_not_availavble_roof_type_list) as number[]).includes(roof_type)) {
        const { projectConfiguration: { projectEnvConfig: { preferred_span: latest_preferred_span, attachment_type: latest_attachment_type } } } = state();
        const rafterSpacing = roof_type === RoofType.SHINGLE && [AttachmentType.STRONGHOLD_ATT_BUTYL, AttachmentType.SM_BUTYL_DTD].includes(latest_attachment_type) ? 1 : 24;
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', rafterSpacing));
        validateOnPreferredSpan(latest_preferred_span, rafterSpacing, roof_type);
      }
      const { projectConfiguration: { projectEnvConfig: { attachment_type: latest_attachment_type } } } = state();
      removeSMButylAttachmentField(productId, roof_type, latest_attachment_type);
    }
    showTornadoSpeedWarning();

    if (field === solarhooksOrTileReplacementApiField && roof_type === RoofType.TILE && value !== prev_roof_type && value !== prev_tile_replacement_or_solarhooks) {
      if (tile_replacement_or_solarhooks === TileAttachmentType.SOLARHOOKS) {
        dispatch(SET_PROJECT_OPTION(solarhookapifield, AttachmentType.SOLARHOOK_FLAT_TILE));
      }
    }

    if (field === solarhooksOrTileReplacementApiField) {
      if (tile_replacement_or_solarhooks === TileAttachmentType.STANDOFFS) {
        dispatch(SET_PROJECT_OPTION(StandoffHeightApiField, StandoffHeightOptions.THREE_INCH));
      }
    }

    if (field === attachmentTypeApiField && roof_type === RoofType.R_PANEL && value !== prev_attachment_type) {
      if ([AttachmentType.PM_9000S, AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY].includes(attachment_type)) {
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_24));
      }
      if (attachment_type === AttachmentType.PM_ADJUST) {
        dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_22));
      }
    }
    if (field === attachmentTypeApiField && value !== prev_attachment_type) {
      if(roof_type === RoofType.SHINGLE){
      if (attachment_type === AttachmentType.FLASHLOC_DUO || attachment_type === AttachmentType.STRONGHOLD_ATT_BUTYL || attachment_type === AttachmentType.SM_BUTYL_DTD) {
        dispatch(SET_PROJECT_OPTION(roofSubstrateApiField, [AttachmentType.SM_BUTYL_DTD, AttachmentType.STRONGHOLD_ATT_BUTYL, AttachmentType.FLASHLOC_DUO].includes(attachment_type) ? null : RoofSubstrate.OSB));
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 1));
        validateOnPreferredSpan(preferred_span, 1, roof_type);
      }
        if ([AttachmentType.L_FOOT_ONLY, AttachmentType.FLASHKIT_PRO, AttachmentType.FLASHLOC_COMP_KIT,
        AttachmentType.FLASHKIT_PRO_SB].includes(attachment_type)) {
        dispatch(SET_PROJECT_OPTION(roofSubstrateApiField, RoofSubstrate.OSB));
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 24));
        validateOnPreferredSpan(preferred_span, 24, roof_type);
      }
      }

      if (attachment_type === AttachmentType.FLASHLOC_DUO && removeUpslopeRail(value, projectVersion) && rail_direction === "NS") {
        dispatch(SET_PROJECT_OPTION(railDirectionApiField, "EW"));
      }
    }
    if (field === roofSubstrateApiField) {
      if (isOsbOrPlywood(roof_type, attachment_type, roof_substrate)) {
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 1));
        validateOnPreferredSpan(preferred_span, 1, roof_type);
      } else {
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 24));
        validateOnPreferredSpan(preferred_span, 24, roof_type);
      }
    }

    if (field === midClampsApiField && !isSMTiltPR(productId)) {
      if (value === MidEndClampChoice.PRO_CLAMP) {
        dispatch(SET_ROW_SPACING(inchesToMeters(1)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(1)));
      } else if (value === MidEndClampChoice.STANDARD_CLAMP) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.25)));
      } else if (value === MidEndClampChoice.UNIVERSAL_CLAMP) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
      } else if (value === MidEndClampChoice.NXT_HORIZON_COMBO_CLAMP) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
      }
    }

    if(field ===  s5RoofManufacturerTypeField && value !== prev_s5_roof_manufacturer) {
      dispatch(SET_PROJECT_OPTION(s5RoofPanelTypeField, null))
      dispatch(SET_PROJECT_OPTION(s5RoofMaterialTypeField, null))
      dispatch(SET_PROJECT_OPTION(s5ClampTypeField, null))
      dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, 0))
      dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, 0))
    }

    if(field === s5RoofPanelTypeField && value !== prev_s5_roof_panel){
      const s5RoofPanelTypeData = filterDataByFields(
        s5AttachmentsData,
        (s5_roof_manufacturer === isGeneric) ? '' : {[s5AttachmentDictKeys.s_5_roof_manufacturer] : s5_roof_manufacturer},
      );
      const selectedS5RoofPanel = getS5DataValue(s5RoofPanelTypeData, s5AttachmentDictKeys.s_5_roof_panel_type, value);
      if (selectedS5RoofPanel !== value) {
        dispatch(SET_PROJECT_OPTION(s5RoofPanelTypeField, selectedS5RoofPanel));
      }
      dispatch(SET_PROJECT_OPTION(s5RoofMaterialTypeField, null))
      dispatch(SET_PROJECT_OPTION(s5ClampTypeField, null))
      dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, 0))
      dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, 0))
    }

    if(field === s5RoofPanelTypeField && s5_roof_manufacturer === isGeneric && value !== isGeneric){
      const updateManufacturer = filterDataByFields(s5AttachmentsData, {[s5AttachmentDictKeys.s_5_roof_panel_type] : value,});
      if (updateManufacturer.length) {
        dispatch(SET_PROJECT_OPTION(s5RoofManufacturerTypeField, updateManufacturer[0][s5AttachmentDictKeys.s_5_roof_manufacturer]));
      }
    }

    const selectedS5Manufacturer = field === s5RoofManufacturerTypeField ? value : s5_roof_manufacturer;
    const selectedS5Panel = field === s5RoofManufacturerTypeField
      ? null
      : (field === s5RoofPanelTypeField ? value : s5_roof_panel);
    const selectedS5Material = [s5RoofManufacturerTypeField, s5RoofPanelTypeField].includes(field)
      ? null
      : (field === s5RoofMaterialTypeField ? value : s5_roof_material);
    let selectedS5Clamp = [s5RoofManufacturerTypeField, s5RoofPanelTypeField].includes(field)
      ? null
      : (field === s5ClampTypeField ? value : s5_clamp);

    const getAvailableS5Clamps = () => {
      if (!selectedS5Manufacturer || !selectedS5Panel || !selectedS5Material) {
        return [];
      }

      const clampData = filterDataByFields(s5AttachmentsData, {
        [s5AttachmentDictKeys.s_5_roof_manufacturer]: selectedS5Manufacturer,
        [s5AttachmentDictKeys.s_5_roof_panel_type]: selectedS5Panel,
        [s5AttachmentDictKeys.s_5_roof_material]: selectedS5Material,
      });
      return extractUniqueS5Values(clampData, s5AttachmentDictKeys.s_5_clamp);
    };

    if (isNxtHorizon(productId) && field === railClampOptionApiField) {
      if (roof_type === RoofType.R_PANEL) {
        dispatch(SET_PROJECT_OPTION(
          attachmentTypeApiField,
          value === NXTRailClampOption.RAIL_CLAMP_ONLY
            ? AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY
            : AttachmentType.PM_ADJUST,
        ));
        dispatch(SET_PROJECT_OPTION(
          materialThicknessApiField,
          value === NXTRailClampOption.RAIL_CLAMP_ONLY
            ? RoofMaterialThickness.GA_24
            : RoofMaterialThickness.GA_22,
        ));
      }

      if (roof_type === RoofType.STANDING_SEAM && s5_or_sci === s5AttachmentPreferenceDict.s_5) {
        if (value === NXTRailClampOption.L_FOOT_AND_RAIL_CLAMP) {
          selectedS5Clamp = null;
          dispatch(SET_PROJECT_OPTION(s5ClampTypeField, null));
          dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, 0));
          dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, 0));
        } else {
          selectedS5Clamp = getDefaultNxtS5AssemblyClamp(getAvailableS5Clamps());
          if (selectedS5Clamp) {
            dispatch(SET_PROJECT_OPTION(s5ClampTypeField, selectedS5Clamp));
          }
        }
      }
    }

    if (
      isNxtHorizon(productId)
      && field === s5RoofMaterialTypeField
      && s5_or_sci === s5AttachmentPreferenceDict.s_5
      && currentEnvConfig.rail_clamp_option === NXTRailClampOption.RAIL_CLAMP_ONLY
    ) {
      selectedS5Clamp = getDefaultNxtS5AssemblyClamp(getAvailableS5Clamps());
      dispatch(SET_PROJECT_OPTION(s5ClampTypeField, selectedS5Clamp));
      dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, 0));
      dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, 0));
    }

    let s5UltimateLoad;
    let s5ShearLoad;
  
    if([s5RoofManufacturerTypeField, s5RoofPanelTypeField, s5RoofMaterialTypeField, s5ClampTypeField, s5AttachmentpreferenceField, railClampOptionApiField].includes(field) && s5_or_sci === s5AttachmentPreferenceDict.s_5 && selectedS5Manufacturer && selectedS5Panel && selectedS5Material && selectedS5Clamp) {
      const capacityClamp = getNxtS5AssemblyCapacityClamp(selectedS5Clamp);
      if(selectedS5Manufacturer === isGeneric && selectedS5Panel === isGeneric && selectedS5Material === isGeneric){
        const filtereds5AttachmentsData = filterDataByFields(s5AttachmentsData, {[s5AttachmentDictKeys.s_5_clamp] : capacityClamp});
        const filteredS5UltimateLoadsData = extractUniqueS5Values(filtereds5AttachmentsData, s5AttachmentDictKeys.s_5_ultimate_load)
        const filteredS5ShearLoadsData = extractUniqueS5Values(filtereds5AttachmentsData, s5AttachmentDictKeys.s_5_shear_load)
        s5UltimateLoad = filteredS5UltimateLoadsData.length ? Math.min(...filteredS5UltimateLoadsData as number[]) : minUltimateLoad("s_5_ultimate_load") 
        s5ShearLoad = filteredS5ShearLoadsData.length ? Math.min(...filteredS5ShearLoadsData as number[]) : minUltimateLoad("s_5_shear_load")
        dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, s5UltimateLoad));
        dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, s5ShearLoad));
      }
      else if(selectedS5Manufacturer === isGeneric && selectedS5Panel === isGeneric){
        const filtereds5AttachmentsData = filterDataByFields(s5AttachmentsData, {[s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material, [s5AttachmentDictKeys.s_5_clamp] : capacityClamp});
        const filteredS5UltimateLoadsData = extractUniqueS5Values(filtereds5AttachmentsData, s5AttachmentDictKeys.s_5_ultimate_load)
        const filteredS5ShearLoadsData = extractUniqueS5Values(filtereds5AttachmentsData, s5AttachmentDictKeys.s_5_shear_load)
        s5UltimateLoad = filteredS5UltimateLoadsData.length ? Math.min(...filteredS5UltimateLoadsData as number[]) : minUltimateLoad("s_5_ultimate_load")
        s5ShearLoad = filteredS5ShearLoadsData.length ?  Math.min(...filteredS5ShearLoadsData as number[]) : minUltimateLoad("s_5_shear_load")
        dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, s5UltimateLoad));
        dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, s5ShearLoad));
      }else{
        s5UltimateLoad = filterDataByFields(s5AttachmentsData, {[s5AttachmentDictKeys.s_5_roof_manufacturer] : selectedS5Manufacturer, [s5AttachmentDictKeys.s_5_roof_panel_type] : selectedS5Panel, [s5AttachmentDictKeys.s_5_roof_material] : selectedS5Material, [s5AttachmentDictKeys.s_5_clamp] : capacityClamp});
        const isNxtS5Assembly = capacityClamp !== selectedS5Clamp;
        if (isNxtS5Assembly && !s5UltimateLoad.length) {
          s5UltimateLoad = filterDataByFields(s5AttachmentsData, {
            [s5AttachmentDictKeys.s_5_clamp]: capacityClamp,
          });
        }
        const filteredS5UltimateLoadsData = isNxtS5Assembly
          ? extractUniqueS5Values(s5UltimateLoad, s5AttachmentDictKeys.s_5_ultimate_load).filter(load => load !== 0)
          : [];
        const filteredS5ShearLoadsData = isNxtS5Assembly
          ? extractUniqueS5Values(s5UltimateLoad, s5AttachmentDictKeys.s_5_shear_load).filter(load => load !== 0)
          : [];
        const s5UltimateFinalLoad = isNxtS5Assembly
          ? (filteredS5UltimateLoadsData.length ? Math.min(...filteredS5UltimateLoadsData as number[]) : minUltimateLoad("s_5_ultimate_load"))
          : (s5UltimateLoad[0][s5AttachmentDictKeys.s_5_ultimate_load] === 0 ? minUltimateLoad("s_5_ultimate_load") : s5UltimateLoad[0][s5AttachmentDictKeys.s_5_ultimate_load]);
        s5ShearLoad = isNxtS5Assembly
          ? (filteredS5ShearLoadsData.length ? Math.min(...filteredS5ShearLoadsData as number[]) : minUltimateLoad("s_5_shear_load"))
          : (s5UltimateLoad[0][s5AttachmentDictKeys.s_5_shear_load] === 0 ? minUltimateLoad("s_5_shear_load") : s5UltimateLoad[0][s5AttachmentDictKeys.s_5_shear_load]);
        dispatch(SET_PROJECT_OPTION(s5UltimateLoadApiField, s5UltimateFinalLoad));
        dispatch(SET_PROJECT_OPTION(s5ShearLoadApiField, s5ShearLoad));
      }
    }

    
  }

  if (isSfmInfinity(productId) || (isSolarMount(productId) && tilt === null) || isNxtHorizon(productId) || isSMTiltPR(productId) || (adjustableTiltSystem(projectVersion) && (isSMTilt(productId) || isNxtTilt(productId)))) {
    if (field === topographicalFactorKztApiField) {
      if ((value < topographicalFactorKzt.min || value > topographicalFactorKzt.max)) {
        dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Topographical Factor must lie in between ${topographicalFactorKzt.min} and ${topographicalFactorKzt.max}`));
      }
      if ((isASCE710(current_building_code) || isASCE705(current_building_code)) && current_topographical_factor_kzt * Number(current_wind_speed) > (isMetricUnit(inputUnit) ? 305.775 : 190)) {
        dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
      }
    }
    if (field === windSpeedApiField) {
      if ((isASCE710(current_building_code) || isASCE705(current_building_code)) && current_topographical_factor_kzt * Number(current_wind_speed) > 190) {
        dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
      }
    }
    if (field === buildingCodeApiField && value !== previousEnvConfig.building_code) {
      if (isASCE716or722(current_building_code)) {
        if (current_topographical_factor_kzt < topographicalFactorKzt.min || current_topographical_factor_kzt > topographicalFactorKzt.max) {
          dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Topographical Factor must lie in between ${topographicalFactorKzt.min} and ${topographicalFactorKzt.max}`));
        } else {
          dispatch(CLEAR_INVALID_FIELD(topographicalFactorKztApiField));
        }
      }
      if ((isASCE710(current_building_code) || isASCE705(current_building_code)) && current_topographical_factor_kzt * Number(current_wind_speed) > (isMetricUnit(inputUnit) ? 305.775 : 190)) {
        dispatch(SET_FIELD_INVALID(topographicalFactorKztApiField, `Please contact Unirac for projects with severe topographical conditions.`));
      }
    }
  }

  if (isSFMInfinity(productId)) {
    const { attachment_type, roof_substrate } = currentEnvConfig;
    if (field === roofTypeApiField) {
      if (value === RoofType.SHINGLE) {
        if (attachment_type === null) {
          dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.FLASHKIT));
        }
        else if (attachment_type === AttachmentType.SFM_BUTYL_DTD) {
          dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 1));
        }
      }
      else {
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 24));
      }
    }
    if (field === attachmentTypeApiField){
      if(current_roof_type === RoofType.SHINGLE && value === AttachmentType.SFM_BUTYL_DTD){
        dispatch(SET_PROJECT_OPTION(roofSubstrateApiField, null));
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 1));  
      }
      else {
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 24));
      }
    }

    if (field === attachmentTypeApiField){
      if(current_roof_type === RoofType.SHINGLE && (value === AttachmentType.SFM_BUTYL_DTD || value === AttachmentType.SM_BUTYL_DTD)){
        if (field === attachmentTypeApiField  && value !== previousEnvConfig[attachmentTypeApiField]) {
          dispatch(SET_PROJECT_OPTION(roofSubstrateApiField, roof_substrate));
        }
      }
    }


    if (field === roofSubstrateApiField){
      if(isOsbOrPlywood(current_roof_type, attachment_type, roof_substrate)){
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 1));
      }
      else {
        dispatch(SET_PROJECT_OPTION('rafter_spacing_inches', 24));
      }
    }

  }

  if (field === midClampsApiField && isSMTiltPR(productId)) {
    if (value === MidEndClampChoice.PRO_CLAMP) {
      dispatch(SET_COLUMN_SPACING(inchesToMeters(1)));
    } else if (value === MidEndClampChoice.STANDARD_CLAMP) {
      dispatch(SET_COLUMN_SPACING(inchesToMeters(0.25)));
    } else if (value === MidEndClampChoice.UNIVERSAL_CLAMP) {
      dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
    }
  }

  if (field === snowLoadApiField) {
    const { lowerLimit, upperLimit } = getSnowLoadLimits();
    const { projectConfiguration: { projectVersion } } = state();
    const moduleLength = store.getState().moduleSelector.modelData.height;
    if (isRM10(productId) || applyCentralSupportForRM5(projectVersion) || isRM10Evolution(productId)) {
      if (checkCentralSupportConditionForSnowloadAndHeight(current_snow_load, moduleLength)) {
        dispatch(SET_PROJECT_OPTION(centralSupportApiField, 1));
      } else {
        dispatch(SET_PROJECT_OPTION(centralSupportApiField, 0));
      }
    }
    if(isEcoFoot2Plus(productId)){
      if (disableMandatoryMidSupportCondition(moduleLength, current_snow_load)) {
        dispatch(SET_PROJECT_OPTION(centralSupportApiField, 1));
        dispatch(SET_PROJECT_OPTION(centralSupportChoiceApiField, centralSupportChoices.MID_SUPPORT));
      } else {
        dispatch(SET_PROJECT_OPTION(centralSupportChoiceApiField, 0));
        dispatch(SET_PROJECT_OPTION(centralSupportApiField, 0));
      }
    }
    if (value < lowerLimit || value > upperLimit) {
      dispatch(SET_FIELD_INVALID(snowLoadApiField, `Snow load must lie between ${lowerLimit} and ${upperLimit}.`));
    }
  }
  if(field === centralSupportApiField && isEcoFoot2Plus(productId)){
    if(value)
    {
      dispatch(SET_PROJECT_OPTION(centralSupportChoiceApiField, centralSupportChoices.MID_SUPPORT));
    }
    else
    {
      dispatch(SET_PROJECT_OPTION(centralSupportChoiceApiField, 0));
    }
  }

  if (field === windSpeedApiField && value !== previousEnvConfig.wind_speed) {
    validateWindSpeed(value);
  }
  else if (field == buildingHeightApiField || field == longestBuildingLengthApiField || field == shortestBuildingLengthApiField || field == parapetHeightNumeric.apiField) {
    const { projectConfiguration: { projectVersion, projectEnvConfig:{risk_category} } } = state();
    if (isAscender(productId) || isMetricUnit(inputUnit)) {
      if (value.toString().split('.').length > 1 && value.toString().split('.')[1].length > 1) {
        dispatch(SET_PROJECT_OPTION(field, parseFloat(value).toFixed(1)));
      } else {
        dispatch(SET_PROJECT_OPTION(field, value));
      }
    }
    else {
      dispatch(SET_PROJECT_OPTION(field, parseInt(String(value))));
    }

    if (field == buildingHeightApiField) {
      validateBuildingHeight(value);
    }
    else if (field == parapetHeightNumeric.apiField) {
      validateParapetHeightNumeric(value);
    }
    else if (field === longestBuildingLengthApiField) {
      validateLongestBuildingLength(value);
      if (isEcoFoot2Plus(productId) || isSMTiltPR(productId) || isAscender(productId) || applyShortestBuildingLength(projectVersion) || (isASCE722(current_building_code) && (isNxtHorizon(productId)|| isSolarMount(productId)))) {
        validateLongestAndShortestBuildingLength(field, value, current_shortest_building_length);
      }
    }
    else if (field === shortestBuildingLengthApiField) {
      validateShortestBuildingLength(value);
      if (isEcoFoot2Plus(productId) || isSMTiltPR(productId) || isAscender(productId) || applyShortestBuildingLength(projectVersion) || (isASCE722(current_building_code) && (isNxtHorizon(productId)|| isSolarMount(productId)))) {
        validateLongestAndShortestBuildingLength(field, current_building_length, value);
      }
    }
  }


  if (field === ballastBlockWeightApiField) {
    const { projectConfiguration: { projectVersion } } = state();
    const ballastBlockWeight = ballastBlockWeightField(inputUnit);
    const weightUnits = isMetricUnit(inputUnit) ? 'kg' : 'lbs';
    if (value < ballastBlockWeight.min || value > ballastBlockWeight.max) {
      dispatch(SET_FIELD_INVALID(ballastBlockWeightApiField, `Block Weight must lie between ${ballastBlockWeight.min} and ${ballastBlockWeight.max} ${weightUnits}`));
    }
    else if (isRMIFIProduct(productId) || isRM10(productId) || isRM10Evolution(productId) || applyRM5Revamp(projectVersion)) {
      if (current_is_half_block_allowed && value <= current_half_block_weight) {
        dispatch(SET_FIELD_INVALID(
          ballastBlockWeightApiField,
          `Half block weight must be less than full block weight (${value} ${weightUnits})`));
      }
      else {
        dispatch(CLEAR_INVALID_FIELD(ballastBlockWeightApiField));
      }
    }
  }

  if ((isRM10orRM10Evo(productId) || isEcoFoot2Plus(productId) || isRMGridFlex(productId) || isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId) ) && shouldUseSetBackDistance("", productId, projectVersion)) {
    const { projectConfiguration: { formState: { invalidFields } } } = state();
    const { lowerLimit, upperLimit } = getSetbackLimits();
    const isSetbackValid = lowerLimit <= current_setback_distance && current_setback_distance <= upperLimit && (
      isMetricUnit(inputUnit) ? current_setback_distance < metersToCms(current_building_height) / 2 : current_setback_distance < current_building_height / 2);
    if (isSetbackValid && [...RM_ECOFOOT_SETBACK_AFFECTING_FIELDS, allowMechanicalAttachmentsApiField].includes(field)
      && !invalidFields.some(({ fieldName }) => RM_ECOFOOT_SETBACK_AFFECTING_FIELDS.includes(fieldName) && fieldName !== setbackDistanceApiField)
    ) {
      validateSetback(productId, currentEnvConfig, projectVersion, inputUnit);
    }
    showTornadoSpeedWarning();
  }

  if (isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)){
    if (field === useDefaultMinAndMaxBlockCount){
      let maxblockcnt = isRM5(productId) ? rm5MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed)) : isRmGridflex10D(productId) ? rmGridflex10MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed), blocks_orientation) : rmGridflex5dMaxBlockCount(isHalfBlockAllowed(is_half_block_allowed), moduleLength);
      dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, maxblockcnt))
      dispatch(SET_PROJECT_OPTION(minBlockCountApiField, minBlockCount(attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(is_half_block_allowed), productId)))
    }
    if (field === useDefaultMaxBlockForNorthCorner){
      dispatch(SET_PROJECT_OPTION(maxBlockNorthCornerCountApiField, rmGridflex10MaxBlockNorthCornerCount(isHalfBlockAllowed(is_half_block_allowed),  state().moduleSelector.modelData.height)))
    }
  }

  if (isRM5(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)){
    if (field === useDefaultMinAndMaxBlockCount){
      let maxblockcnt = isRM5(productId) ? rm5MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed)) : isRmGridflex10D(productId) ? rmGridflex10MaxBlockCount(isHalfBlockAllowed(is_half_block_allowed), blocks_orientation) : rmGridflex5dMaxBlockCount(isHalfBlockAllowed(is_half_block_allowed), moduleLength);
      dispatch(SET_PROJECT_OPTION(maxBlockCountApiField, maxblockcnt))
      dispatch(SET_PROJECT_OPTION(minBlockCountApiField, minBlockCount(attachment_optimization_criteria === AttachmentOptimization.FULLY_ATTACHED, isHalfBlockAllowed(is_half_block_allowed), productId)))
    }
    if (field === useDefaultMaxBlockForNorthCorner){
      dispatch(SET_PROJECT_OPTION(maxBlockNorthCornerCountApiField, rmGridflex10MaxBlockNorthCornerCount(isHalfBlockAllowed(is_half_block_allowed),  state().moduleSelector.modelData.height)))
    }
  }

  if (field === rafterSpacingApiField) {
    validateRafterSpacing(value);
  }


  if (field === preferredSpanApiField || field === rafterSpacingApiField) {
    dispatch(SET_PROJECT_OPTION(field, parseInt(String(value))));
    validatePreferredspanAndRafterSpacing(field, productId, parseInt(String(current_preferred_span)), parseInt(String(current_rafter_spacing_inches)), current_roof_type, current_attachment_type, current_roof_substrate, inputUnit);
  }

  if (field === preferredSpanApiField) {
    validateSpans(productId, value);
  }

  if (isRMGridFlex(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
    const {projectConfiguration:{projectEnvConfig}} = state();

    if (field === buildingCodeApiField && isASCE710(value)) {
      dispatch(SET_PROJECT_OPTION(meanRecurrenceApiField, '50'));
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(50)));
    }

    if (field === seismicIpApiField){
      validateSeismicImportanceFactor(value);
    }
    if (field === snowIsApiField){
      validateSnowImportanceFactor(value);
    }
    if (field === windIwApiField){
      validateWindImportanceFactor(value);
    }

    if (field === fullyAdheredApiField) {
      if (!value) {
        dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField, 1));
      }
      else {
        dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField, 0));
        deleteManualAttachmentsOnPanels(productId);
      }
    }

    if (field === loadSharingTypeApiField) {
      if (value === loadSharingOptions.default.value) {
        deleteManualAttachmentsOnPanels(productId);
        dispatch(SET_PROJECT_OPTION(fullyAdheredApiField, 1));
        dispatch(SET_PROJECT_OPTION(allowManualAttachmentsApiField, 0));
        dispatch(SET_PROJECT_OPTION(snowIsApiField, 1));
        dispatch(SET_PROJECT_OPTION(seismicIpApiField, 1));
        dispatch(SET_PROJECT_OPTION(windIwApiField, 1));
      }
      if ([loadSharingOptions.fmg.value,loadSharingOptions.dsa.value].includes(value)) {
        deleteManualAttachmentsOnPanels(productId);
        dispatch(SET_PROJECT_OPTION(snowIsApiField, SNOW_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY[current_risk_category - 1]));
        dispatch(SET_PROJECT_OPTION(seismicIpApiField, SEISMIC_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY[current_risk_category - 1]));
        dispatch(SET_PROJECT_OPTION(windIwApiField, 1));
      }
    }

    if (field === riskCategoryApiField && [loadSharingOptions.fmg.value,loadSharingOptions.dsa.value].includes(projectEnvConfig?.load_sharing_type)) {
      dispatch(SET_PROJECT_OPTION(snowIsApiField, SNOW_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY[value - 1]));
      dispatch(SET_PROJECT_OPTION(seismicIpApiField, SEISMIC_IMPORTANCE_FACTOR_BASED_ON_RISK_CATGORY[value - 1]));
    }

  }
};


function onSnowLoadChanged(value: string, productId: number, projectEnvConfig: projectEnvConfig) {
  if (isSFMFamily(productId)) {
    const snowLoad = parseInt(value, 10);
    const currentStaggerAttachmentsValue = projectEnvConfig.stagger_attachments;
    const staggerAttachmentsWasNotSelected = currentStaggerAttachmentsValue.toString() !== YES_OPTION.value;
    if (!isNaN(snowLoad) && shouldUseStaggerAttachmentsForSfm(snowLoad) && staggerAttachmentsWasNotSelected) {
      dispatch(SET_PROJECT_OPTION(staggerAttachments.apiField, Boolean(YES_OPTION.value)));
      showWarningAlert(`Stagger Attachments selection has been set to "${YES_OPTION.name}" due to the design snow load`);
    }
  }
}

function onStaggerAttachmentsChanged(value: string, productId: number, projectEnvConfig: projectEnvConfig) {
  if (isSFMFamily(productId)) {
    const { snow_load } = projectEnvConfig;
    if (!isNaN(snow_load) && shouldUseStaggerAttachmentsForSfm(snow_load) && value === NO_OPTION.value) {
      showWarningAlert(`Staggered attachments are recommended for snow loads greater than ${MINIMUM_SNOW_LOAD_THAT_REQUIRES_STAGGER_ATTACHMENTS} psf`);
    }
  }
}

export const updateEnviromentalFactors = (
  zipCode: string,
  building_code: number,
  productId: number,
  risk_category: number,
  newZipCode?: string,
  cords?: { lat: number, lng: number },
) => {
  const { lat, lng } = getMapCenter();
  dispatch(
    GET_ENVIRONMENTAL_FACTORS(
      cords && cords.lat || lat,
      cords && cords.lng || lng,
      newZipCode || zipCode,
      building_code || (isOnlyAsce716ProductFamily(productId) ? asce_716.value : asce_710.value),
      productId,
      risk_category,
    ),
  );
};

export const onZipCodeChange = (
  newZipCode: string,
  productId: number,
  initData: projectEnvConfig,
  mapType: string,
) => {
  const zipCodeLowerCase = newZipCode.toUpperCase();
  dispatch(SET_CITY_NAME(''));

  if (!zipCodeLowerCase){
    dispatch(SET_PROJECT_OPTION(buildingCodeApiField, ""))
  }

  if (zipCodeLowerCase !== initData.zipcode) {
    dispatch(CLEAR_ENV_FACTORS_FOR());
    getAreaByZip(zipCodeLowerCase, (data: ICITY_STATE) => {
      const { address, city, lat, lng, state } = data;
      if (city.length && state.length) {
        dispatch(SET_CITY_NAME(`${city}, ${state}`));
      }

      if (address.length) {
        dispatch(SET_LOCATION(address));
      }

      const stateBuildingCode = changeBuildingCodeByState(state);

      if (lat !== undefined && lng !== undefined && mapType !== 'white') {
        setCenterForCurrentMap(lat, lng);
      }
      const buildingCodeForLookup = stateBuildingCode !== undefined ? stateBuildingCode : initData.building_code;
      // Use the code changeBuildingCodeByState just applied. A Florida zip is
      // ASCE 7-22, and that is the code the hazard lookup must request.
      if (!initData.imported_project) {
        updateEnviromentalFactors(
          zipCodeLowerCase,
          buildingCodeForLookup,
          productId,
          initData.risk_category,
          zipCodeLowerCase,
          { lat, lng },
        );

      }
    });
  }
  updateProjectOption(
    'zipcode',
    newZipCode,
    initData.zipcode,
    productId,
    initData,
  );
};

export const SelectRadios = () => {
  const activeCheckboxes = getActiveCheckboxes();
  Object.keys(activeCheckboxes).map(f => {
    const field = activeCheckboxes[f];
    const radioInput = document.querySelector(`input[value="${field}"]`);

    if (radioInput) {
      const selectionControlContainer = radioInput.closest(
        '.md-selection-control-container',
      );
      if (selectionControlContainer) {
        selectionControlContainer.classList.add('active');
      }
    }
  });
};

const unselectRadioOption = (value: any) => {
  const radio = document.querySelector(`input[value="${value}"]`);
  if (radio && radio.closest('.md-selection-control-group')) {
    const radios = radio.closest('.md-selection-control-group').children;
    Array.from(radios).forEach(el => el.classList.remove('active'));
  }
};

const setResidentialsExtraInputsValueForAsce716 = (productId: number) => {
  const buildingType = (isRMFamily(productId) || isEcoFoot2Plus(productId))? flat.value : gable.value;
  dispatch(SET_PROJECT_OPTION('building_type', buildingType));
  dispatch(SET_PROJECT_OPTION('pro_clamps', 1));
  dispatch(SET_PROJECT_OPTION('risk_category', 2));
};

const unsetResidentialsExtraInputsValueForAsce716 = (productId: number) => {
  dispatch(REMOVE_OPTION_FROM_CONFIG('pro_clamps'));
  !isRMFamily(productId) && !isEcoFoot2Plus(productId) && dispatch(REMOVE_OPTION_FROM_CONFIG('risk_category'));
};

const setExtraInputsValueForAsce722 = () => {
  dispatch(SET_PROJECT_OPTION(seismicSds.apiField, seismicSds.min));
  dispatch(SET_PROJECT_OPTION(seismicSd1.apiField, seismicSd1.min));
  dispatch(SET_PROJECT_OPTION(tornadoSpeed.apiField, tornadoSpeed.min));
  dispatch(SET_PROJECT_OPTION(longTransitionPeriods.apiField, longTransitionPeriods.min));
  dispatch(SET_PROJECT_OPTION(longestRowLength.apiField, longestRowLength.min));
  dispatch(SET_PROJECT_OPTION(shortestRowLength.apiField, shortestRowLength.min));
  dispatch(SET_PROJECT_OPTION('risk_category', 2));
};

const unsetExtraInputsValueForAsce722 = () => {
  dispatch(REMOVE_OPTIONS_FROM_CONFIG(seismicSds.apiField, seismicSd1.apiField, tornadoSpeed.apiField, longTransitionPeriods.apiField, longestRowLength.apiField, shortestRowLength.apiField));
};

const setProperRoofPitchForResidentialsASCE716 = (buildingCode: number, buildingType: number) => {
  const {
    projectConfiguration: { productId, projectVersion },
    tiltedRoof: { roofPitch },
  } = state()
  if (isRMDT(productId)) {
    dispatch(SET_TILTED_ROOF(null));
    return;
  }

  if (
    isRMFamily(productId) &&
    greaterThanEqualToProjectVersion(
      projectVersion,
      VERSION_MAP['default_roofpitch_value_changes'],
    )
  ) {
    const roofPitchAfterBuildingCodeChange = roofPitch && roofPitch !== '0' ? roofPitch : '1';
    dispatch(SET_TILTED_ROOF(roofPitchAfterBuildingCodeChange));
    return;
  }

  if (
    (isASCE716or722BuildingCode(buildingCode) && isFlatRoof(buildingType)) ||
    isSMTiltPR(productId) ||
    isGFT(productId) ||
    isULA(productId)
  ) {
    dispatch(SET_TILTED_ROOF(null));
  } else {
    if (isRM5(productId) || isRM10orRM10Evo(productId)) {
      dispatch(SET_TILTED_ROOF('0'));
    } else {
      dispatch(SET_TILTED_ROOF('---'));
    }
  }
};

export const validateSetback = (productId: number, projectEnvConfig: projectEnvConfig, projectVersion: string, inputUnit: number) => {
  if (applyEcoFoot2PlusRM10andEvoSetbackChanges(productId, projectVersion) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
    const seismic_setback_distance = isMetricUnit(inputUnit) ? round(feetsToCms(getSeismicSetback(projectEnvConfig, productId)), 1) : round(getSeismicSetback(projectEnvConfig, productId), 1);
    const seismic_setback_satisfied = projectEnvConfig.setback_distance >= seismic_setback_distance;
    changeSetbackDistanceWarning(seismic_setback_distance, seismic_setback_satisfied, productId);
  }
};

export function uAnchorRoof(current_roof_type, sub_category){
  let u_anchor_roof_id;
  if(current_roof_type == RmRoofType.SBS || current_roof_type == RmRoofType.COATED){
      const u_anchor_roof_type = roof_type_mapping(current_roof_type);
      u_anchor_roof_id = u_anchor_roof_type[sub_category];
    }
  else{
      u_anchor_roof_id = roof_type_mapping(current_roof_type);
    }
  return u_anchor_roof_id;
}


const validateLongestBuildingLength = (value: number) => {
  const { lowerLimit, upperLimit } = getLongestBuildingLengthLimits();
  dispatch(CLEAR_INVALID_FIELD(longestBuildingLengthApiField));
  if (value < lowerLimit || value > upperLimit) {
    dispatch(SET_FIELD_INVALID(longestBuildingLengthApiField, `Longest Building Length must lie between ${lowerLimit} and ${upperLimit}`));
  }
};

const validateShortestBuildingLength = (value: number) => {
  const { lowerLimit, upperLimit } = getShortestBuildingLengthLimits();
  dispatch(CLEAR_INVALID_FIELD(shortestBuildingLengthApiField));
  if (value < lowerLimit || value > upperLimit) {
    dispatch(SET_FIELD_INVALID(shortestBuildingLengthApiField, `Shortest Building Length must lie between ${lowerLimit} and ${upperLimit}`));
  }
};

const validateBuildingHeight = (value: number) => {
  const { lowerLimit, upperLimit } = getBuildingHeightLimits();
  dispatch(CLEAR_INVALID_FIELD(buildingHeightApiField));
  if (value < lowerLimit || value > upperLimit) {
    dispatch(SET_FIELD_INVALID(buildingHeightApiField, `Building height must lie between ${lowerLimit} and ${upperLimit}`));
  }
};

const validateParapetHeightNumeric = (value: number) => {
  dispatch(CLEAR_INVALID_FIELD(parapetHeightNumeric.apiField));
  if (value < parapetHeightNumeric.min || value > parapetHeightNumeric.max) {
    dispatch(SET_FIELD_INVALID(parapetHeightNumeric.apiField, `Parapet height must lie between ${parapetHeightNumeric.min} and ${parapetHeightNumeric.max}`));
  }
};

const validateWindSpeed = (value: number) => {
  const { lowerLimit, upperLimit } = getWindSpeedLimits();
  dispatch(CLEAR_INVALID_FIELD(windSpeedApiField));
  if (value < lowerLimit || value > upperLimit) {
    dispatch(SET_FIELD_INVALID(windSpeedApiField, `Wind speed must lie between ${lowerLimit} and ${upperLimit}.`));
  }
};

const validateLongestAndShortestBuildingLength = (field: string, longest_building_length: number, shortest_building_length: number) => {
  const { lowerLimit: lowerLimitForShortest, upperLimit: upperLimitForShortest } = getShortestBuildingLengthLimits();
  const { lowerLimit: lowerLimitForLongest, upperLimit: upperLimitForLongest } = getLongestBuildingLengthLimits();
  if (longest_building_length < lowerLimitForLongest || longest_building_length > upperLimitForLongest ||
    shortest_building_length < lowerLimitForShortest || shortest_building_length > upperLimitForShortest) {
    return;
  }
  if (longest_building_length < shortest_building_length) {
    if (field == longestBuildingLengthApiField && longest_building_length) {
      dispatch(SET_FIELD_INVALID(longestBuildingLengthApiField, `Longest Building Length must be greater than Shortest Building Length`));
      dispatch(CLEAR_INVALID_FIELD(shortestBuildingLengthApiField));
    }
    else if (field == shortestBuildingLengthApiField && shortest_building_length) {
      dispatch(CLEAR_INVALID_FIELD(longestBuildingLengthApiField));
      dispatch(SET_FIELD_INVALID(shortestBuildingLengthApiField, `Shortest Building Length must be smaller than Longest Building Length`));
    }
  }
  else {
    dispatch(CLEAR_INVALID_FIELD(longestBuildingLengthApiField));
    dispatch(CLEAR_INVALID_FIELD(shortestBuildingLengthApiField));
  }
}

export const updateProjectOptionOnNxtHdRailTypeChange = () => {
  const { projectConfiguration: { projectEnvConfig: { roof_type }, railsProductId, projectEnvConfig: { mid_clamps_choices, end_clamps_choices, tile_replacement_or_solarhooks} } } = state();
  if (mid_clamps_choices !== smClampsOptions.nxtHorizonComboClamps.value) {
    dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.nxtHorizonComboClamps.value));
  }
  const validEndClampChoices = isNxtHorizonHD(railsProductId)
    ? [smClampsOptions.nxtHorizonComboClamps.value]
    : [smClampsOptions.nxtHorizonComboClamps.value, smClampsOptions.nxtHorizonHiddenEndClamps.value];
  if (!validEndClampChoices.includes(end_clamps_choices)) {
    dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.nxtHorizonComboClamps.value));
  }
  if (isNxtHorizonHD(railsProductId)) {
    dispatch(SET_PROJECT_OPTION(railFinishApiField, 'AL'));
    if (tile_replacement_or_solarhooks === TileAttachmentType.STANDOFFS) {
      dispatch(SET_PROJECT_OPTION(solarhooksOrTileReplacementApiField, TileAttachmentType.TILE_REPLACEMENT));
    }
    // if (tile_replacement_or_solarhooks === TileAttachmentType.SOLARHOOKS) {
    //   dispatch(SET_PROJECT_OPTION(solarhookapifield, AttachmentType.SOLARHOOK_FLAT_TILE));
    // }
    // dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.STRONGHOLD_ATT_KIT_COMP));
    if (roof_type === RoofType.R_PANEL) {
      dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_24));
      dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.NXT_S5_PROTEA_BRACKET_ASSEMBLY));
      dispatch(SET_PROJECT_OPTION(railClampOptionApiField, NXTRailClampOption.RAIL_CLAMP_ONLY));
    }
    if (roof_type === RoofType.STANDING_SEAM) {
      dispatch(SET_PROJECT_OPTION(materialThicknessApiField, RoofMaterialThickness.GA_22));
      dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.MINI_1SS));
    }
  } 
  validateInputs();
  };

export const updateProjectOptionOnRailTypeChange = (allPanelsDeleted: boolean = false) => {
  const { projectConfiguration: { projectVersion, projectEnvConfig: { rafter_spacing_inches, building_code, roof_type, attachment_type, s5_or_sci, domestic_content, is_domestic_mlpe_required }, inputUnit, railsProductId, productId, projectEnvConfig: { tilt, end_clamps_choices, tile_replacement_or_solarhooks} } } = state();
  if (isSolarMount(productId) && tilt === null) {
    if (isSMAscenderFlush(railsProductId)) {
      dispatch(SET_PROJECT_OPTION(buildingCodeApiField, isASCE722(building_code) ? building_code : asce_716.value));
      dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.universalClamps.value));
      dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.universalClamps.value));
      dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.L_FOOT_ONLY));
      dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, isMetricUnit(inputUnit) ? 61 : 24));
      dispatch(SET_PROJECT_OPTION(railFinishApiField, 'AL'));
      dispatch(SET_PROJECT_OPTION(meanRecurrenceApiField, '50'));
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(50)));
      dispatch(SET_PROJECT_OPTION(riskCategoryApiField, RiskCategory.II));
      dispatch(SET_PROJECT_OPTION(residentalBuildingTypes.apiField, gable.value));
      if(roof_type !== RoofType.SHINGLE){
        dispatch(SET_PROJECT_OPTION(roofTypeApiField, RoofType.SHINGLE));
      }
      if (!allPanelsDeleted) {
        switchProjectToASCE716(productId);
      }
      if (!isMetricUnit(inputUnit)) {
        dispatch(TOGGLE_INPUT_UNIT());  // switching to metric unit -  this actionwill trigger updateProjectOptionOnInputUnitChange
      }
    }
    else {
      dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, isMetricUnit(inputUnit) ? 61 : 24));
      validateRafterSpacing(rafter_spacing_inches);
      if (!isNxtHorizon(productId) && applySMDomesticContentClampFilter(projectVersion) && (domestic_content === 1 || is_domestic_mlpe_required === 1)) {
        dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.standardClamps.value));
        dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.standardClamps.value));
      }
      if (isMetricUnit(inputUnit)) {
        dispatch(TOGGLE_INPUT_UNIT());  // switching to us customary unit - this actionwill trigger setProjectOptionOnInputUnitChange
      }
    }
    validateInputs();
  } else if (isSMTiltPRWithAscender(railsProductId)) {
      dispatch(SET_PROJECT_OPTION(buildingCodeApiField, isASCE722(building_code) ? building_code : asce_716.value));
      dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.universalClamps.value));
      dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.universalClamps.value));
      dispatch(SET_PROJECT_OPTION(attachmentTypeApiField, AttachmentType.L_FOOT_ONLY));
      dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, isMetricUnit(inputUnit) ? 61 : 24));
      dispatch(SET_PROJECT_OPTION(railFinishApiField, 'AL'));
      dispatch(SET_PROJECT_OPTION(meanRecurrenceApiField, '50'));
      dispatch(SET_PROJECT_OPTION(designLifeFactorFc.apiField, get_design_life_factor(50)));
      dispatch(SET_PROJECT_OPTION(riskCategoryApiField, RiskCategory.II));
      dispatch(SET_PROJECT_OPTION(residentalBuildingTypes.apiField, gable.value));
      dispatch(SET_PROJECT_OPTION(roofTypeApiField, RoofType.GABLE));
      if (!allPanelsDeleted) {
        switchProjectToASCE716(productId);
      }
      if (!isMetricUnit(inputUnit)) {
        dispatch(TOGGLE_INPUT_UNIT());  // switching to metric unit -  this actionwill trigger updateProjectOptionOnInputUnitChange
      }
    } else {
      dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, isMetricUnit(inputUnit) ? 61 : 24));
      if (!isNxtHorizon(productId) && applySMDomesticContentClampFilter(projectVersion) && (domestic_content === 1 || is_domestic_mlpe_required === 1)) {
        dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.standardClamps.value));
        dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.standardClamps.value));
      }
      if (isMetricUnit(inputUnit)) {
        dispatch(TOGGLE_INPUT_UNIT());  // switching to us customary unit - this actionwill trigger setProjectOptionOnInputUnitChange
      }
    }
    validateInputs();
  };

export const setProjectOptionOnInputUnitChange = () => {
  const {
    projectConfiguration: {
      inputUnit,
      productId,
      projectEnvConfig: {
        preferred_span, wind_speed, building_height, shortest_building_length, building_length,
        snow_load, flat_roof_snow_load, setback_distance, elevation: elevationNumber, block_weight, half_block_weight, parapet_height_input,
        uplift_allowable, shear_allowable, tornado_speed
      }
    }
  } = state();
  if (isMetricUnit(inputUnit)) {
    // dispatch(SET_PROJECT_OPTION(raf, isSMAscenderFlush(railsProductId) ? 1 : _.round(inchesToCms(Number(rafter_spacing_inches)), 1)));
    dispatch(SET_PROJECT_OPTION(preferredSpanApiField, _.round(inchesToCms(Number(preferred_span)), 1)));
    dispatch(SET_PROJECT_OPTION(windSpeedApiField, Math.round(milesToKms(wind_speed))));
    dispatch(SET_PROJECT_OPTION(tornadoSpeed.apiField, Math.round(milesToKms(tornado_speed))));
    dispatch(SET_PROJECT_OPTION(buildingHeightApiField, _.round(feetsToMeters(building_height), 1)));
    dispatch(SET_PROJECT_OPTION(shortestBuildingLengthApiField, _.round(feetsToMeters(shortest_building_length), 1)));
    dispatch(SET_PROJECT_OPTION(longestBuildingLengthApiField, _.round(feetsToMeters(building_length), 1)));
    dispatch(SET_PROJECT_OPTION(elevation.apiField, _.round(feetsToMeters(elevationNumber))));
    dispatch(SET_PROJECT_OPTION(snowLoadApiField, _.round(psfToKpa(snow_load), 2)));
    if (flat_roof_snow_load !== null && flat_roof_snow_load !== undefined) {
      dispatch(SET_PROJECT_OPTION(flatRoofSnowLoadApiField, _.round(psfToKpa(flat_roof_snow_load), 2)));
    }
    if (isRM10orRM10Evo(productId) || isRM5(productId) || isEcoFoot2Plus(productId) || isRmGridflex10D(productId)) {
      dispatch(SET_PROJECT_OPTION(setbackDistanceApiField, _.round(feetsToCms(setback_distance), 1)));
      dispatch(SET_PROJECT_OPTION(ballastBlockWeightApiField, _.round(lbsToKgs(block_weight), 1)));
      if (!isEcoFoot2Plus(productId)) {
        dispatch(SET_PROJECT_OPTION(ballastBlockHalfWeightApiField, _.round(lbsToKgs(half_block_weight), 1)));
        dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, _.round(lbsToKgs(uplift_allowable), 1)));
        dispatch(SET_PROJECT_OPTION(shearAllowableApiField, _.round(lbsToKgs(shear_allowable), 1)));
      }
    }
    if(isRM10Evolution(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      dispatch(SET_PROJECT_OPTION(rmIFIParapetHeightApiField, _.round(inchesToMeters(parapet_height_input), 1)));
    }
    if(isSMTiltPRWithAscender(productId)){
      dispatch(SET_PROJECT_OPTION(parapetHeightNumeric.apiField, _.round(inchesToMeters(parapet_height_input), 1)));
    }
  }
  else {
    // dispatch(SET_PROJECT_OPTION(rafterSpacingApiField, isSMAscenderFlush(railsProductId) ? 1 : Math.round(cmsToInches(Number(rafter_spacing_inches)))));
    
    dispatch(SET_PROJECT_OPTION(preferredSpanApiField, Math.round(cmsToInches(Number(preferred_span)))));
    dispatch(SET_PROJECT_OPTION(windSpeedApiField, Math.round(kmsToMiles(wind_speed))));
    dispatch(SET_PROJECT_OPTION(tornadoSpeed.apiField, Math.round(kmsToMiles(tornado_speed))));
    dispatch(SET_PROJECT_OPTION(buildingHeightApiField, Math.round(metersToFeets(building_height))));
    dispatch(SET_PROJECT_OPTION(shortestBuildingLengthApiField, Math.round(metersToFeets(shortest_building_length))));
    dispatch(SET_PROJECT_OPTION(longestBuildingLengthApiField, _.round(metersToFeets(building_length))));
    dispatch(SET_PROJECT_OPTION(elevation.apiField, Math.round(metersToFeets(elevationNumber))));
    dispatch(SET_PROJECT_OPTION(snowLoadApiField, _.round(kpaToPsf(snow_load), 2)));
    if (flat_roof_snow_load !== null && flat_roof_snow_load !== undefined) {
      dispatch(SET_PROJECT_OPTION(flatRoofSnowLoadApiField, _.round(kpaToPsf(flat_roof_snow_load), 2)));
    }
    if (isRM10orRM10Evo(productId) || isRM5(productId) || isEcoFoot2Plus(productId)) {
      dispatch(SET_PROJECT_OPTION(setbackDistanceApiField, _.round(cmsToFeets(setback_distance), 1)));
      dispatch(SET_PROJECT_OPTION(ballastBlockWeightApiField, _.round(kgsToLbs(block_weight))));
      if (!isEcoFoot2Plus(productId)) {
        dispatch(SET_PROJECT_OPTION(ballastBlockHalfWeightApiField, _.round(kgsToLbs(half_block_weight))));
        dispatch(SET_PROJECT_OPTION(upliftAllowableApiField, _.round(kgsToLbs(uplift_allowable))));
        dispatch(SET_PROJECT_OPTION(shearAllowableApiField, _.round(kgsToLbs(shear_allowable))));
      }
    }
    if(isRM10Evolution(productId) || isRmGridflex10D(productId) || isRmGridflex5Rwdi(productId)) {
      dispatch(SET_PROJECT_OPTION(rmIFIParapetHeightApiField, _.round(metersToInches(parapet_height_input), 1)));
    }
  }
  updateRoofDimensionsOnInputUnitChange();
  if (isSolarMount(productId)) {
    validateInputs();
  }
};


const validateInputs = () => {
  const { projectConfiguration: { productId, projectEnvConfig: { building_length, shortest_building_length, building_height, parapet_height_num, wind_speed, preferred_span, rafter_spacing_inches } } } = state();
  validateBuildingHeight(building_height);
  validateParapetHeightNumeric(parapet_height_num);
  validateShortestBuildingLength(shortest_building_length);
  validateLongestAndShortestBuildingLength(longestBuildingLengthApiField, building_length, shortest_building_length);
  validateWindSpeed(wind_speed);
  if (!isCommercialProduct(productId)) {
    validateSpans(productId, preferred_span);
    validateRafterSpacing(rafter_spacing_inches);
  }
};


const validatePreferredspanAndRafterSpacing = (field, productId, preferred_span, rafter_spacing_inches, roof_type, attachment_type, roof_substrate, inputUnit) => {
  if (field === preferredSpanApiField) {
    if (!isMetricUnit(inputUnit)) {
      if (Number(preferred_span) > 72 && isSMTiltPR(productId)) {
        dispatch(SET_FIELD_INVALID(preferredSpanApiField, "Please enter preferred span <72''"));
      }
    } else {
      if (Number(preferred_span) > 183 && (isSMTiltPR(productId) || isSMTiltPRWithAscender(productId))) {
        dispatch(SET_FIELD_INVALID(preferredSpanApiField, "Please enter preferred span <183cm"))
      }
    }
    validateSpansMinMax(productId, preferred_span);
  }
  if (field === rafterSpacingApiField) {
    if (Number(rafter_spacing_inches) < rafterSpacing().min || Number(rafter_spacing_inches) > rafterSpacing().max) {
      dispatch(SET_FIELD_INVALID(rafterSpacingApiField, `${ribOrRafter(roof_type)} should be ranging from ${rafterSpacing().min} and ${rafterSpacing().max}`));
    }
  }
  if (isMetalX(productId) && isSunframeMicroRail(productId)) {
    return;
  }
  if (!isSMTiltPR(productId)){
    validateOnPreferredSpan(preferred_span, rafter_spacing_inches, roof_type);
  }
};

const validateOnPreferredSpan = (preferred_span, rafter_spacing_inches, roof_type) => {
  const errorMessage = `preferred span must be a multiple of ${ribOrRafter(roof_type)}`;
  if (!!preferred_span && !!rafter_spacing_inches && isSpanMultipleOfRafterSpacing(preferred_span, rafter_spacing_inches)) {
    dispatch(CLEAR_INVALID_FIELD(preferredSpanApiField));
  } else {
    dispatch(SET_FIELD_INVALID(preferredSpanApiField, errorMessage));
  }
};

const updateRoofDimensionsOnInputUnitChange = () => {
  const { roofsSelector: { mapType }, drawingManager: { roofs } } = state();
  if (roofs && !!Object.keys(roofs)?.length) {
    Object.keys(roofs).forEach(roofId => {
      if (isGoogleMap(mapType)) {
        updateRoofDimensionsGoogleMap(Number(roofId), false);
      }
      else if (isBingMap(mapType)) {
        updateRoofDimensionsBingMap(Number(roofId), false);
      }
    });
  }
};

export function productChange(field, value){
  const {projectConfiguration: { projectEnvConfig : { wind_speed }}} = state();
  if (value === 34) {
    dispatch(SET_PRODUCT_ID(34));
    dispatch(SET_RAILS_PRODUCT_ID(34));
    dispatch(SET_PROJECT_OPTION(field, value));
    dispatch(SET_PROJECT_OPTION(endClampsApiField, smClampsOptions.nxtHorizonHiddenEndClamps.value));
    dispatch(SET_PROJECT_OPTION(midClampsApiField, smClampsOptions.nxtHorizonComboClamps.value));
    dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
    dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
    validateWindSpeed(wind_speed);
    const { moduleSelector: { modelData: { thickness } } } = state();
        if (thickness) {
          const thicknessValue = typeof thickness === 'string' ? parseFloat(thickness) : thickness;
          if (!isNaN(thicknessValue) && !checkThickness(thicknessValue, 34, false)) {
            dispatch(CLEAR_INVALID_FIELD('height'));
            dispatch(SET_MODEL_DATA_HAS_ERROR(true));
            dispatch(OPEN_DRAWER_PAGE('module-selection'));
            dispatch(SET_FLYOUT_VERIFIED(MODULE_SELECTION_PAGE, false, true));
          }
        }
  }
  if (value === 9 ) {
    dispatch(SET_PRODUCT_ID(99));
    dispatch(SET_RAILS_PRODUCT_ID(9));
    dispatch(SET_PROJECT_OPTION(field, value));
    validateWindSpeed(wind_speed);
  }
}

export const US_SHORT_STATE_NAMES={
  newMexico: 'NM',
  florida: 'FL',
};

const buildingCode716DefaultStates = [US_SHORT_STATE_NAMES.newMexico];
const buildingCode722DefaultStates = [US_SHORT_STATE_NAMES.florida];
export function changeBuildingCodeByState(stateCode: string){
  const { projectConfiguration: { productId, shouldAutoApplyStateBuildingCode, projectEnvConfig, projectVersion }, user } = state();
  const permissions = (user && user.permissions) || [];
  
  if (!shouldAutoApplyStateBuildingCode) {
    return projectEnvConfig.building_code;
  }

  const currentBuildingCode = projectEnvConfig.building_code;
  const canUseAsce722 = productHasAsce722BuildingCode(productId)
    || applyAsce722AccessForRM10Evo(productId, projectVersion)
    || applyAsce722AccessForEcoFoot2Plus(productId, projectVersion)
    || (disabled722BuildingCodeProducts(productId) && permissions.includes(ACCESS_FOR_7_22_PERMISSION));
  
  if (buildingCode716DefaultStates.includes(stateCode) && productHasAsce716BuildingCode(productId)){
    if (currentBuildingCode === asce_716.value) {
      return asce_716.value;
    }
    dispatch(SET_PROJECT_OPTION(buildingCodeApiField,asce_716.value));
    dispatch(SET_PROJECT_OPTION('mean_recurrence_interval', '50'));
    return asce_716.value
  } else if (buildingCode722DefaultStates.includes(stateCode) && canUseAsce722){
    if (currentBuildingCode === asce_722.value) {
      return asce_722.value;
    }
    dispatch(SET_PROJECT_OPTION(buildingCodeApiField,asce_722.value));
    let envFactorsApiFields = [windSpeedApiField, snowLoadApiField, seismicSsApiField, seismicS1ApiField, seismicSds.apiField, seismicSd1.apiField, deadLoadFactorApiField]
    envFactorsApiFields.forEach((field)=>(dispatch(SET_PROJECT_OPTION(field, ''))))
    dispatch(SET_PROJECT_OPTION(riskCategoryApiField, RiskCategory.II))
    dispatch(SET_PROJECT_OPTION(elevation.apiField, ''))
    dispatch(SET_PROJECT_OPTION(tornadoSpeed.apiField, 0))
    dispatch(SET_PROJECT_OPTION(deadLoadFactorApiField, 0.6))
    dispatch(SET_PROJECT_OPTION('mean_recurrence_interval', '50'));
    return asce_722.value;
  }
}

export const removeSMButylAttachmentField = (productId, roof_type, attachment_type) => {
  if(isSolarMount(productId) && roof_type === RoofType.OTHERS && attachment_type === AttachmentType.SM_BUTYL_DTD) {
    dispatch(REMOVE_OPTION_FROM_CONFIG(attachmentTypeApiField));
    dispatch(SET_FIELD_INVALID(attachmentTypeApiField, "Please select an attachment type"));
    dispatch(SET_FLYOUT_VERIFIED(RAIL_SYSTEM_PAGE, false, true));
  }
};
